import React, { useState, useEffect, useRef } from "react";
import {
  MainContainer,
  TitleFormContainer,
  TitleForm,
  FormDescription,
  TitleSection,
  SectionContainer3Columns,
  SectionContainer2Columns,
  ActivePasiveText,
  BackArrowContainer,
  SectionContainer1Column,
  CuentasContainer,
} from "./FormJuridicalAllElements";

import Alert from "@mui/material/Alert";
import Divider from "@mui/material/Divider";
import TextField from "@mui/material/TextField";
import { Button, FormControl, Typography } from "@mui/material";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { es } from "date-fns/locale";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import InputAdornment from "@mui/material/InputAdornment";

//LOADING COMPONENT
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Box } from "@mui/system";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Tooltip from "@mui/material/Tooltip";
import HelpIcon from "@mui/icons-material/Help";
import InputLabel from "@mui/material/InputLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormLabel from "@mui/material/FormLabel";

import FileUpload from "react-mui-fileuploader";

import { IoArrowBackCircleSharp } from "react-icons/io5";
//navigate
import { useNavigate } from "react-router-dom";

//signature pad
import Popup from "reactjs-popup";
import "./sigCanvas.css";

import SignaturePad from "react-signature-canvas";

//firebase
import firebase from "firebase/compat/app";
import { firebaseApp } from "../../utils/firebase";
import "firebase/compat/storage";
import "firebase/compat/firestore";
//email
import * as emailjs from "@emailjs/browser";

//FORM
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";

const FormJuridicalAll = (props) => {
  const navigate = useNavigate();

  emailjs.init("8a6YjyUTerawhlWGO");
  const db = firebase.firestore(firebaseApp);

  let multilineValue =
    "- Autorizo a Fiduvalor Casa de Valores S. A., Depósito Centralizado de Valores (DECEVALE) y Depósito Centralizado de Valores DCV - BCE, a proprocionar directa o indirectamente la información contenida en este formulario y/o una copia de este formulario a cualquier autoridad fiscal pertinente o cualquier parte autorizada, para auditar o realizar un control similiar de Fiduvalor Casa de Valores S. A. para fines fiscales, así como a divulgar a tales autoridades fiscales o tal parte, cualquier información adicional que pudiese poseer Fiduvalor Casa de Valores S. A., Depósito Centralizado de Valores (DECEVALE) y Depósito Centralizado de Valores DCV - BCE y que es pertinente para mi calificación para cualquier beneficio reclamado con base en esta certificación. - Acepto que la información contenida en este formulario y la información relacionada con mis cuentas en Fiduvalor Casa de Valores S. A., Depósito Centralizado de Valores (DECEVALE) y Depósito Centralizado de Valores DCV - BCE (incluso la información sobre los saldos de cuentas y pagos recibidos) se notifique a las autoridades fiscales perinentes, y que estas autoridades proporcionen esta información a cualquier otro país enumerado en la lista http://www.oecd.org/tax/automatic-exchange/ como a un país en el cual soy residente para fines fiscales. - Me comprometo a avisar inmediatamente a Fiduvalor Casa de Valores S. A., Depósito Centralizado de Valores (DECEVALE) y Depósito Centralizado de Valores DCV - BCE sobre cualquier cambio en las circunstancias que motive que la información contenida en este documento sea incorrecta y a proporcionar a Fiduvalor Casa de Valores S. A., Depósito Centralizado de Valores (DECEVALE) y Depósito Centralizado de Valores DCV - BCE un formulario actualizado y apropiado de Auto-certificación de Residencia Fiscal en un plazo de 30 días a partir de la fecha del cambio en las circunstancias. Las transacciones que realice con Fiduvalor Casa de Valores S. A. tienen y tendrán fuente y origen lícitos y no provienen ni provendrán de fondos obtenidos de forma ilegal o ilícita, ni tampoco son o serán destinados a ninguna actividad de esta naturaleza o relacionada con la producción, consumo, comercialización de sustancias estupefacientes y sicotrópicas o cualquier otra actividad delictiva tipificada en la Ley Vigente. Eximo a Fiduvalor Casa de Valores S. A., de toda responsabilidad, inclusive frente a terceros, si esta declaratoria fuese falsa o errónea. Renuncio expresamente a ejecutar cualquier acción o pretensión tanto en el ámbito civil, penal como de cualquier otra índole. Autorizo expresamente a Fiduvalor Casa de Valores S. A., a realizar el análisis que considere pertinente e informar documentadamente a las autoridades competentes en caso de presentarse transacciones inusuales e injustificadas.";

  const { setOnItemClickBack, onItemClickBack, setIsJuridicalContinueButton } =
    props;

  const [juridicalPersonForm, setJuridicalPersonForm] = useState({});
  const [isDeliveringToDB, setIsDeviveringToDB] = useState(false);

  const [isEmisor, setIsEmisor] = useState(false);

  //Loading
  const [isLoading, setIsLoading] = useState(false);

  //Condicionales
  const [isEu, setIsEu] = useState(false);
  const [isNoEu, setIsNoEu] = useState(false);
  const [isNCuentas, setIsNCuentas] = useState(false);
  const [isNCuentas2, setIsNCuentas2] = useState(false);
  const [hasAccepted, setHasAccepted] = useState(false);
  const [isDeclaring, setIsDeclaring] = useState(false);

  //Condicionales Persona que Ejerce el Control
  const [isEntidadDeposito, setIsEntidadDeposito] = useState(false);
  const [isEntidadAcciones, setIsEntidadAcciones] = useState(false);
  const [isEntidadPasiva, setIsEntidadPasiva] = useState(false);
  const [isNPersonasEjercen1, setIsNPersonasEjercen1] = useState(false);
  const [isNPersonasEjercen2, setIsNPersonasEjercen2] = useState(false);
  const [isNPersonasEjercen3, setIsNPersonasEjercen3] = useState(false);

  //Condicionales Residencia Fiscal
  const [isPais1, setIsPais1] = useState(false);
  const [isPais2, setIsPais2] = useState(false);
  const [isPais3, setIsPais3] = useState(false);

  //**************************************** UseState TextField FORMS**********************************************/
  //DATOS GENERALES
  const [razonSocialValue, setRazonSocialValue] = useState("");
  const [nombreComercialValue, setNombreComercialValue] = useState("");
  const [rucValue, setRucValue] = useState("");
  const [emailValue, setEmailValue] = useState("");
  const [actividadValue, setActividadValue] = useState("");

  // DATOS REPRESENTANTE LEGAL
  const [nombresValue, setNombresValue] = useState("");
  const [apellidosValue, setApellidosValue] = useState("");
  const [ciPasaporteValue, setCiPasaporteValue] = useState("");
  const [nacionalidadValue, setNacionalidadValue] = useState("");
  const [fechaNacimientoValue, setFechaNacimientoValue] = useState(null);
  const [estCivilValue, setEstCivilValue] = useState("");
  const [telefonoDomicilioValue, setTelefonoDomicilioValue] = useState("");
  const [telefonoCelularValue, setTelefonoCelularValue] = useState("");

  //INFORMACIÓN DE LA EMPRESA
  const [ciudadValue, setCiudadValue] = useState("");
  const [barrioValue, setBarrioValue] = useState("");
  const [direccionValue, setDireccionValue] = useState("");
  const [codigoPostalValue, setCodigoPostalValue] = useState("");
  const [telefonoEmpresaValue, setTelefonoEmpresaValue] = useState("");
  const [sucursalesValue, setSucursalesValue] = useState("");
  const [direccionSucursalesValue, setDireccionSucursalesValue] = useState("");

  //PERSONA QUE EJERCE EL CONTROL
  const [instFinancieraValue, setInstFinancieraValue] = useState("");
  const [entidadDepositoValue, setEntidadDepositoValue] = useState("");
  const [entidadAccionesValue, setEntidadAccionesValue] = useState("");
  const [nombreMercadoValue, setNombreMercadoValue] = useState("");
  const [entidadGubernamentalValue, setEntidadGubernamentalValue] =
    useState("");
  const [entidadPasivaValue, setEntidadPasivaValue] = useState("");
  const [nPersonasEjercen, setNPersonasEjercen] = useState("");
  const [personasEjercen1Value, setPersonasEjercen1Value] = useState("");
  const [personasEjercen2Value, setPersonasEjercen2Value] = useState("");
  const [personasEjercen3Value, setPersonasEjercen3Value] = useState("");

  //RESIDENCIA FISCAL
  const [isEuValue, setIsEuValue] = useState("");
  const [
    identificacionContibuyenteSnnValue,
    setIdentificacionContibuyenteSnnValue,
  ] = useState("");
  const [isNoEuValue, setIsNoEuValue] = useState("");
  const [cuantosPaisesNoEuValue, setCuantosPaisesNoEuValue] = useState("");

  const [paisResidente1, setPaisResidente1] = useState("");
  const [paisResidente1SNN, setPaisResidente1SNN] = useState("");
  const [paisResidente2, setPaisResidente2] = useState("");
  const [paisResidente2SNN, setPaisResidente2SNN] = useState("");
  const [paisResidente3, setPaisResidente3] = useState("");
  const [paisResidente3SNN, setPaisResidente3SNN] = useState("");

  //INFORMACIÓN FINANCIERA
  //activos
  const [cajaBancosValue, setCajaBancosValue] = useState("");
  const [cuentasPorCobrarValue, setCuentasPorCobrarValue] = useState("");
  const [activosFijosValue, setActivosFijosValue] = useState("");
  const [valorInversionesValue, setValorInversionesValue] = useState("");
  const [otrosActivosValue, setOtrosActivosValue] = useState("");
  const [totalActivosValue, setTotalActivosValue] = useState("");
  const [ingresosMensualesValue, setIngresosMensualesValue] = useState("");

  //pasivoss
  const [cuentasPorPagarValue, setCuentasPorPagarValue] = useState("");
  const [obligacionesFinancierasValue, setObligacionesFinancierasValue] =
    useState("");
  const [otrosPasivosValue, setOtrosPasivosValue] = useState("");
  const [totalPasivosValue, setTotalPasivosValue] = useState("");
  const [patrimonioValue, setPatrimonioValue] = useState("");
  const [egresosMensualesValue, setEgresosMensualesValue] = useState("");

  //CUENTAS
  //Cuenta 1
  const [nCuentasValue, setNCuentasValue] = useState("");
  const [institucionFinanciera1Value, setInstitucionFinanciera1Value] =
    useState("");
  const [tipoCuentaValue, setTipoCuentaValue] = useState("");
  const [numeroCuenta1Value, setNumeroCuenta1Value] = useState("");
  //Cuenta 2
  const [institucionFinanciera2Value, setInstitucionFinanciera2Value] =
    useState("");
  const [tipoCuenta2Value, setTipoCuenta2Value] = useState("");
  const [numeroCuenta2Value, setNumeroCuenta2Value] = useState("");

  //PERFIL DE RIESGO
  const [objetoInversionValue, setObjetoInversionValue] = useState("");
  const [necesidadLiquidezValue, setNecesidadLiquidezValue] = useState("");
  const [experienciaValue, setExperienciaValue] = useState("");
  const [plazoInversionValue, setPlazoInversionValue] = useState("");
  const [disponibilidadRecursosValue, setDisponibilidadRecursosValue] =
    useState("");

  //DECLARACIÓN
  const [declaraValue, setDeclaraValue] = useState("");
  // FILES
  const [firmaFileValue, setFirmaFileValue] = useState([]);
  const [nombreCompletoFirmanteValue, setNombreCompletoFirmanteValue] =
    useState("");
  const [cedulaPasaporteFirmanteValue, setCedulaPasaporteFirmanteValue] =
    useState("");
  const [copiaCedulaTitularFileValue, setCopiaCedulaTitularFileValue] =
    useState();
  const [copiaPapeletaTitularFileValue, setCopiaPapeletaTitularFileValue] =
    useState();

  const [copiaPlanillasFileValue, setCopiaPlanillasFileValue] = useState();
  const [copiaNombramientoFileValue, setCopiaNombramientoFileValue] =
    useState();
  const [copiaRUCFileValue, setCopiaRUCFileValue] = useState();
  const [copiaEscrituraFileValue, setCopiaEscrituraFileValue] = useState();
  const [copiaEstatutosFileValue, setCopiaEstatutosFileValue] = useState();
  const [
    copiaEstadosFinancierosFileValue,
    setCopiaEstadosFinancierosFileValue,
  ] = useState();

  const [copiaNominaAccionistasFileValue, setCopiaNominaAccionistasFileValue] =
    useState();
  const [copiaCertificadoCumplimiento, setCopiaCertificadoCumplimiento] =
    useState();

  const [
    copiaDeclaracionImpuestosFileValue,
    setCopiaDeclaracionImpuestosFileValue,
  ] = useState();
  const [
    copiaCertificadoBancarioFileValue,
    setCopiaCertificadoBancarioFileValue,
  ] = useState();

  const [, setOtroDeclaraValue] = useState("");

  const [direccionRepresentanteValue, setDireccionRepresentanteValue] =
    useState("");
  const [correoRepresentanteValue, setCorreoRepresentanteValue] = useState("");

  const [isCargoPublicoValue, setIsCargoPublicoValue] = useState("");
  const [isFamiliarCargoPublicoValue, setIsFamiliarCargoPublicoValue] =
    useState("");
  const [isTrabajaCargoPublicoValue, setIsTrabajaCargoPublicoValue] =
    useState("");

  /* OnChangeTextFields */
  //DATOS GENERALES
  const onRazonSocialChange = (e) => setRazonSocialValue(e.target.value);
  const onNombreComercialChange = (e) =>
    setNombreComercialValue(e.target.value);
  const onRucChange = (e) => setRucValue(e.target.value);
  const onEmailChange = (e) => setEmailValue(e.target.value);
  const onActividadEconomicaChange = (e) => setActividadValue(e.target.value);

  // DATOS REPRESENTANTE LEGAL
  const onNombresChange = (e) => setNombresValue(e.target.value);
  const onApellidosChange = (e) => setApellidosValue(e.target.value);
  const onCiPasaporteChange = (e) => setCiPasaporteValue(e.target.value);
  const onNacionalidadChange = (e) => setNacionalidadValue(e.target.value);
  const onEstCivilChange = (e) => setEstCivilValue(e.target.value);
  const onTelefonoDomicilioChange = (e) =>
    setTelefonoDomicilioValue(e.target.value);
  const onTelefonoCelularChange = (e) =>
    setTelefonoCelularValue(e.target.value);
  const onDireccionRepresentanteChange = (e) =>
    setDireccionRepresentanteValue(e.target.value);
  const onCorreoRepresentanteChange = (e) =>
    setCorreoRepresentanteValue(e.target.value);
  const onIsCargoPublicoChange = (e) => setIsCargoPublicoValue(e.target.value);
  const onIsFamiliarCargoPublicoChange = (e) =>
    setIsFamiliarCargoPublicoValue(e.target.value);
  const onIsTrabajaCargoPublicoValueChange = (e) =>
    setIsTrabajaCargoPublicoValue(e.target.value);

  //INFORMACIÓN DE LA EMPRESA
  const onCiudadChange = (e) => setCiudadValue(e.target.value);
  const onBarrioChange = (e) => setBarrioValue(e.target.value);
  const onDireccionChange = (e) => setDireccionValue(e.target.value);
  const onCodigoPostalChange = (e) => setCodigoPostalValue(e.target.value);
  const onTelefonoEmpresaChange = (e) =>
    setTelefonoEmpresaValue(e.target.value);
  const onSucursalesChange = (e) => setSucursalesValue(e.target.value);
  const onDireccionSucursalesChange = (e) =>
    setDireccionSucursalesValue(e.target.value);

  //PERSONA QUE EJERCE EL CONTROL
  const onInstFinancieraChange = (e) => setInstFinancieraValue(e.target.value);
  const onEntidadDepositoChange = (e) =>
    setEntidadDepositoValue(e.target.value);
  const onEntidadAccionesChange = (e) =>
    setEntidadAccionesValue(e.target.value);
  const onNombreMercadoChange = (e) => setNombreMercadoValue(e.target.value);
  const onEntidadGubernamentalChange = (e) =>
    setEntidadGubernamentalValue(e.target.value);
  const onEntidadPasivaChange = (e) => setEntidadPasivaValue(e.target.value);
  const onNPersonasEjercen = (e) => setNPersonasEjercen(e.target.value);
  const onPersonasEjercen1Change = (e) =>
    setPersonasEjercen1Value(e.target.value);
  const onPersonasEjercen2Change = (e) =>
    setPersonasEjercen2Value(e.target.value);
  const onPersonasEjercen3Change = (e) =>
    setPersonasEjercen3Value(e.target.value);

  //RESIDENCIA FISCAL
  const onIsEuValueChange = (e) => setIsEuValue(e.target.value);
  const onIdentificacionContribuyenteSnnChange = (e) =>
    setIdentificacionContibuyenteSnnValue(e.target.value);
  const onIsNoEuChange = (e) => setIsNoEuValue(e.target.value);
  const onCuantosPaisesNoEuChange = (e) =>
    setCuantosPaisesNoEuValue(e.target.value);

  const onPaisResidente1 = (e) => setPaisResidente1(e.target.value);
  const onPaisResidente1SNN = (e) => setPaisResidente1SNN(e.target.value);

  const onPaisResidente2 = (e) => setPaisResidente2(e.target.value);
  const onPaisResidente2SNN = (e) => setPaisResidente2SNN(e.target.value);

  const onPaisResidente3 = (e) => setPaisResidente3(e.target.value);
  const onPaisResidente3SNN = (e) => setPaisResidente3SNN(e.target.value);

  //INFORMACIÓN FINANCIERA
  //activos
  const onCajaBancosChange = (e) => setCajaBancosValue(e.target.value);
  const onCuentasPorCobrarChange = (e) =>
    setCuentasPorCobrarValue(e.target.value);
  const onActivosFijosChange = (e) => setActivosFijosValue(e.target.value);
  const onValorInversionesChange = (e) =>
    setValorInversionesValue(e.target.value);
  const onOtrosActivosChange = (e) => setOtrosActivosValue(e.target.value);

  const onIngresosMensualesChange = (e) =>
    setIngresosMensualesValue(e.target.value);

  //pasivos

  const onCuentasPorPagarChange = (e) =>
    setCuentasPorPagarValue(e.target.value);
  const onObligacionesFinancierasChange = (e) =>
    setObligacionesFinancierasValue(e.target.value);
  const onOtrosPasivosChange = (e) => setOtrosPasivosValue(e.target.value);
  const onEgresosMensualesChange = (e) =>
    setEgresosMensualesValue(e.target.value);

  //CUENTAS
  //Cuenta1
  const onNCuentasChange = (e) => setNCuentasValue(e.target.value);
  const onInstitucionFinanciera1Change = (e) =>
    setInstitucionFinanciera1Value(e.target.value);
  const onTipoCuentaChange = (e) => setTipoCuentaValue(e.target.value);
  const onNumeroCuenta1Change = (e) => setNumeroCuenta1Value(e.target.value);

  //Cuenta2
  const onInstitucionFinanciera2Change = (e) =>
    setInstitucionFinanciera2Value(e.target.value);
  const onTipoCuenta2Change = (e) => setTipoCuenta2Value(e.target.value);
  const onNumeroCuenta2Change = (e) => setNumeroCuenta2Value(e.target.value);

  //PERFIL DE RIESGO
  const onObjetoInversionChange = (e) =>
    setObjetoInversionValue(e.target.value);
  const onNecesidadLiquidezChange = (e) =>
    setNecesidadLiquidezValue(e.target.value);
  const onExperienciaValue = (e) => setExperienciaValue(e.target.value);
  const onPlazoInversionChange = (e) => setPlazoInversionValue(e.target.value);
  const onDisponibilidadRecursosChange = (e) =>
    setDisponibilidadRecursosValue(e.target.value);

  // Declara
  const onDeclaraChange = (e) => setDeclaraValue(e.target.value);
  const onOtroDeclaraChange = (e) => setOtroDeclaraValue(e.target.value);

  //FILES
  const onNombreCompletoFirmanteChange = (e) =>
    setNombreCompletoFirmanteValue(e.target.value);
  const onCedulaPasaporteFirmanteChange = (e) =>
    setCedulaPasaporteFirmanteValue(e.target.value);

  useEffect(() => {
    if (entidadDepositoValue === "Si") {
      setIsEntidadDeposito(true);
    } else {
      setIsEntidadDeposito(false);
    }
  }, [entidadDepositoValue]);

  useEffect(() => {
    if (entidadAccionesValue === "Si") {
      setIsEntidadAcciones(true);
    } else {
      setIsEntidadAcciones(false);
    }
  }, [entidadAccionesValue]);

  useEffect(() => {
    if (entidadPasivaValue === "Si") {
      setIsEntidadPasiva(true);
    } else {
      setIsEntidadPasiva(false);
    }
  }, [entidadPasivaValue]);

  useEffect(() => {
    if (nPersonasEjercen === "1") {
      setIsNPersonasEjercen1(true);
      setIsNPersonasEjercen2(false);
      setIsNPersonasEjercen3(false);
    } else if (nPersonasEjercen === "2") {
      setIsNPersonasEjercen2(true);
      setIsNPersonasEjercen1(false);
      setIsNPersonasEjercen3(false);
    } else if (nPersonasEjercen === "3") {
      setIsNPersonasEjercen3(true);
      setIsNPersonasEjercen1(false);
      setIsNPersonasEjercen2(false);
    }
  }, [nPersonasEjercen]);

  useEffect(() => {
    if (cuantosPaisesNoEuValue === "1") {
      setIsPais1(true);
      setIsPais2(false);
      setIsPais3(false);
    } else if (cuantosPaisesNoEuValue === "2") {
      setIsPais2(true);
      setIsPais1(false);
      setIsPais3(false);
    } else if (cuantosPaisesNoEuValue === "3") {
      setIsPais3(true);
      setIsPais2(false);
      setIsPais1(false);
    }
  }, [cuantosPaisesNoEuValue]);

  useEffect(() => {
    if (declaraValue === "Otros") {
      setIsDeclaring(true);
    } else {
      setIsDeclaring(false);
    }
  }, [declaraValue]);

  useEffect(() => {
    if (isEuValue === "Si") {
      setIsEu(true);
    } else {
      setIsEu(false);
    }
  }, [isEuValue]);

  useEffect(() => {
    if (isNoEuValue === "Si") {
      setIsNoEu(true);
    } else {
      setIsNoEu(false);
    }
  }, [isNoEuValue]);

  useEffect(() => {
    setTotalActivosValue(
      Number(cajaBancosValue) +
        Number(cuentasPorCobrarValue) +
        Number(activosFijosValue) +
        Number(valorInversionesValue) +
        Number(otrosActivosValue)
    );
  }, [
    cajaBancosValue,
    cuentasPorCobrarValue,
    activosFijosValue,
    valorInversionesValue,
    otrosActivosValue,
  ]);

  useEffect(() => {
    setTotalPasivosValue(
      Number(cuentasPorPagarValue) +
        Number(obligacionesFinancierasValue) +
        Number(otrosPasivosValue)
    );
  }, [cuentasPorPagarValue, obligacionesFinancierasValue, otrosPasivosValue]);

  useEffect(() => {
    setPatrimonioValue(Number(totalActivosValue) - Number(totalPasivosValue));
  }, [totalPasivosValue, totalActivosValue]);

  useEffect(() => {
    if (nCuentasValue === "1") {
      setIsNCuentas(true);
      setIsNCuentas2(false);
    } else if (nCuentasValue === "2") {
      setIsNCuentas2(true);
      setIsNCuentas(false);
    }
  }, [nCuentasValue]);

  //Uploading all to firebase
  const uploadAll = async () => {
    let fileData = [];
    setProgress((prevProgress) => prevProgress + 5);

    //SUBIR FIRMA
    if (typeof firmaFileValue !== "undefined" && firmaFileValue.length > 0) {
      await firebase
        .storage()
        .ref(`/juridicalform/firmas/${rucValue}_FIRMA`)
        .put(firmaFileValue[0])
        .then(async () => {
          await firebase
            .storage()
            .ref(`/juridicalform/firmas/${rucValue}_FIRMA`)
            .getDownloadURL()
            .then((url) => {
              fileData[0] = url;
            })
            .catch(() => {
              fileData[0] = "";
            });
        });
    } else {
      fileData[0] = "No envió";
    }
    setProgress((prevProgress) => prevProgress + 5);

    //Firma Realizada en app
    if (typeof imageURL === "string") {
      await firebase
        .storage()
        .ref(`/juridicalform/firmas/${rucValue}_FIRMA`)
        .putString(imageURL, "data_url")
        .then(async () => {
          await firebase
            .storage()
            .ref(`/juridicalform/firmas/${rucValue}_FIRMA`)
            .getDownloadURL()
            .then((url) => {
              fileData[0] = url;
            })
            .catch(() => {
              fileData[0] = "";
            });
        });
    }
    setProgress((prevProgress) => prevProgress + 5);

    //SUBIR CEDULA TITULAR

    if (
      typeof copiaCedulaTitularFileValue !== "undefined" &&
      copiaCedulaTitularFileValue.length > 0
    ) {
      await firebase
        .storage()
        .ref(`/juridicalform/copiacedula/${rucValue}_CEDULA_REPRESENTANTE`)
        .put(copiaCedulaTitularFileValue[0])
        .then(async () => {
          await firebase
            .storage()
            .ref(`/juridicalform/copiacedula/${rucValue}_CEDULA_REPRESENTANTE`)
            .getDownloadURL()
            .then((url) => {
              fileData[1] = url;
            })
            .catch(() => {
              fileData[1] = "";
            });
        });
    } else {
      fileData[1] = "No envió";
    }
    setProgress((prevProgress) => prevProgress + 5);

    //SUBIR COPIA PAPELETA
    if (
      typeof copiaPapeletaTitularFileValue !== "undefined" &&
      copiaPapeletaTitularFileValue.length > 0
    ) {
      await firebase
        .storage()
        .ref(`/juridicalform/copiapapeleta/${rucValue}_PAPELETA_REPRESENTANTE`)
        .put(copiaPapeletaTitularFileValue[0])
        .then(async () => {
          await firebase
            .storage()
            .ref(
              `/juridicalform/copiapapeleta/${rucValue}_PAPELETA_REPRESENTANTE`
            )
            .getDownloadURL()
            .then((url) => {
              fileData[2] = url;
            })
            .catch(() => {
              fileData[2] = "";
            });
        });
    } else {
      fileData[2] = "No envió";
    }
    setProgress((prevProgress) => prevProgress + 5);

    //SUBIR COPIA DE PLANILLA
    if (
      typeof copiaPlanillasFileValue !== "undefined" &&
      copiaPlanillasFileValue.length > 0
    ) {
      await firebase
        .storage()
        .ref(`/juridicalform/copiaplanilla/${rucValue}_PLANILLA`)
        .put(copiaPlanillasFileValue[0])
        .then(async () => {
          await firebase
            .storage()
            .ref(`/juridicalform/copiaplanilla/${rucValue}_PLANILLA`)
            .getDownloadURL()
            .then((url) => {
              fileData[3] = url;
            })
            .catch(() => {
              fileData[3] = "";
            });
        });
    } else {
      fileData[3] = "No envió";
    }
    setProgress((prevProgress) => prevProgress + 5);

    //SUBIR COPIA DE NOMBRAMIENTO
    if (
      typeof copiaNombramientoFileValue !== "undefined" &&
      copiaNombramientoFileValue.length > 0
    ) {
      await firebase
        .storage()
        .ref(`/juridicalform/copianombramiento/${rucValue}_NOMBRAMIENTO`)
        .put(copiaNombramientoFileValue[0])
        .then(async () => {
          await firebase
            .storage()
            .ref(`/juridicalform/copianombramiento/${rucValue}_NOMBRAMIENTO`)
            .getDownloadURL()
            .then((url) => {
              fileData[4] = url;
            })
            .catch(() => {
              fileData[4] = "";
            });
        });
    } else {
      fileData[4] = "No envió";
    }
    setProgress((prevProgress) => prevProgress + 5);

    //SUBIR COPIA DE RUC
    if (
      typeof copiaRUCFileValue !== "undefined" &&
      copiaRUCFileValue.length > 0
    ) {
      await firebase
        .storage()
        .ref(`/juridicalform/copiaruc/${rucValue}_RUC`)
        .put(copiaRUCFileValue[0])
        .then(async () => {
          await firebase
            .storage()
            .ref(`/juridicalform/copiaruc/${rucValue}_RUC`)
            .getDownloadURL()
            .then((url) => {
              fileData[5] = url;
            })
            .catch(() => {
              fileData[5] = "";
            });
        });
    } else {
      fileData[5] = "No envió";
    }
    setProgress((prevProgress) => prevProgress + 5);

    //SUBIR COPIA DE ESCRITURA DE CONSTITUCIÓN
    if (
      typeof copiaEscrituraFileValue !== "undefined" &&
      copiaEscrituraFileValue.length > 0
    ) {
      await firebase
        .storage()
        .ref(`/juridicalform/copiaescritura/${rucValue}_ESCRITURA_CONSTITUCION`)
        .put(copiaEscrituraFileValue[0])
        .then(async () => {
          await firebase
            .storage()
            .ref(
              `/juridicalform/copiaescritura/${rucValue}_ESCRITURA_CONSTITUCION`
            )
            .getDownloadURL()
            .then((url) => {
              fileData[6] = url;
            })
            .catch(() => {
              fileData[6] = "";
            });
        });
    } else {
      fileData[6] = "No envió";
    }
    setProgress((prevProgress) => prevProgress + 10);

    //SUBIR COPIA DE ESTATUTOS SOCIALES
    if (
      typeof copiaEstatutosFileValue !== "undefined" &&
      copiaEstatutosFileValue.length > 0
    ) {
      await firebase
        .storage()
        .ref(`/juridicalform/copiaestatutos/${rucValue}_ESTATUTOS_SOCIALES`)
        .put(copiaEstatutosFileValue[0])
        .then(async () => {
          await firebase
            .storage()
            .ref(`/juridicalform/copiaestatutos/${rucValue}_ESTATUTOS_SOCIALES`)
            .getDownloadURL()
            .then((url) => {
              fileData[7] = url;
            })
            .catch(() => {
              fileData[7] = "";
            });
        });
    } else {
      fileData[7] = "No envió";
    }
    setProgress((prevProgress) => prevProgress + 10);

    //SUBIR CERTIFICADO BANCARIO

    if (
      typeof copiaCertificadoBancarioFileValue !== "undefined" &&
      copiaCertificadoBancarioFileValue.length > 0
    ) {
      await firebase
        .storage()
        .ref(`/juridicalform/copiacertificado/${rucValue}_CERTIFICADO_BANCARIO`)
        .put(copiaCertificadoBancarioFileValue[0])
        .then(async () => {
          await firebase
            .storage()
            .ref(
              `/juridicalform/copiacertificado/${rucValue}_CERTIFICADO_BANCARIO`
            )
            .getDownloadURL()
            .then((url) => {
              fileData[8] = url;
            })
            .catch(() => {
              fileData[8] = "";
            });
        });
    } else {
      fileData[8] = "No envió";
    }
    setProgress((prevProgress) => prevProgress + 5);

    //SUBIR ESTADOS FINANCIEROS

    if (
      typeof copiaEstadosFinancierosFileValue !== "undefined" &&
      copiaEstadosFinancierosFileValue.length > 0
    ) {
      await firebase
        .storage()
        .ref(
          `/juridicalform/copiaestadosfinancieros/${rucValue}_ESTADOS_FINANCIEROS`
        )
        .put(copiaEstadosFinancierosFileValue[0])
        .then(async () => {
          await firebase
            .storage()
            .ref(
              `/juridicalform/copiaestadosfinancieros/${rucValue}_ESTADOS_FINANCIEROS`
            )
            .getDownloadURL()
            .then((url) => {
              fileData[9] = url;
            })
            .catch(() => {
              fileData[9] = "";
            });
        });
    } else {
      fileData[9] = "No envió";
    }
    setProgress((prevProgress) => prevProgress + 5);

    //SUBIR NOMINA ACCIONISTAS

    if (
      typeof copiaNominaAccionistasFileValue !== "undefined" &&
      copiaNominaAccionistasFileValue.length > 0
    ) {
      await firebase
        .storage()
        .ref(`/juridicalform/copianominaacciones/${rucValue}_NOMINA_ACCIONES`)
        .put(copiaNominaAccionistasFileValue[0])
        .then(async () => {
          await firebase
            .storage()
            .ref(
              `/juridicalform/copianominaacciones/${rucValue}_NOMINA_ACCIONES`
            )
            .getDownloadURL()
            .then((url) => {
              fileData[10] = url;
            })
            .catch(() => {
              fileData[10] = "";
            });
        });
    } else {
      fileData[10] = "No envió";
    }
    setProgress((prevProgress) => prevProgress + 5);

    //SUBIR CERTIFICADO CUMPLIMIENTO

    if (
      typeof copiaCertificadoCumplimiento !== "undefined" &&
      copiaCertificadoCumplimiento.length > 0
    ) {
      await firebase
        .storage()
        .ref(
          `/juridicalform/copiacertificadocumplimiento//${rucValue}_CERTIFICADO_CUMPLIMIENTO_OBLIGACIONES`
        )
        .put(copiaCertificadoCumplimiento[0])
        .then(async () => {
          await firebase
            .storage()
            .ref(
              `/juridicalform/copiacertificadocumplimiento//${rucValue}_CERTIFICADO_CUMPLIMIENTO_OBLIGACIONES`
            )
            .getDownloadURL()
            .then((url) => {
              fileData[11] = url;
            })
            .catch(() => {
              fileData[11] = "";
            });
        });
    } else {
      fileData[11] = "No envió";
    }
    setProgress((prevProgress) => prevProgress + 5);

    //SUBIR DECLARACION SRI
    if (
      typeof copiaDeclaracionImpuestosFileValue !== "undefined" &&
      copiaDeclaracionImpuestosFileValue.length > 0
    ) {
      await firebase
        .storage()
        .ref(`/juridicalform/copiadeclaracion/${rucValue}_DECLARACION_IMPUESTO`)
        .put(copiaDeclaracionImpuestosFileValue[0])
        .then(async () => {
          await firebase
            .storage()
            .ref(
              `/juridicalform/copiadeclaracion/${rucValue}_DECLARACION_IMPUESTO`
            )
            .getDownloadURL()
            .then((url) => {
              fileData[12] = url;
            })
            .catch(() => {
              fileData[12] = "";
            });
        });
    } else {
      fileData[12] = "No envió";
    }
    setProgress((prevProgress) => prevProgress + 5);
    //85
    //Enviar a colección y crear usuario auth
    await firebase
      .auth()
      .createUserWithEmailAndPassword(emailValue, emailValue)
      .catch((error) => {
        //handle errors
        var errorCode = error.code;
        if (errorCode == "auth/email-already-in-use") {
          console.log("Email en uso");
        } else {
          console.log("Email no en uso");
        }
      })
      .then(async () => {
        setProgress((prevProgress) => prevProgress + 5);
        await new Promise((r) => setTimeout(r, 5000));
        setProgress((prevProgress) => prevProgress + 5);

        await db
          .collection("juridicalPersonCollection")
          .add({
            EsEmisor: isEmisor,
            CargoPublico: isCargoPublicoValue,
            FamiliarCargoPublico: isFamiliarCargoPublicoValue,
            TrabajaCargoPublico: isTrabajaCargoPublicoValue,
            DireccionRepresentante: direccionRepresentanteValue,
            CorreoRepresentante: correoRepresentanteValue,
            RazonSocial: razonSocialValue,
            NombreComercial: nombreComercialValue,
            RUC: rucValue,
            Email: emailValue,
            ActividadEconomica: actividadValue,
            Nombres: nombresValue,
            Apellidos: apellidosValue,
            CIPasaporte: ciPasaporteValue,
            Nacionalidad: nacionalidadValue,
            FechaNacimiento: fechaNacimientoValue,
            EstadoCivil: estCivilValue,
            TelefonoDomicilio: telefonoDomicilioValue,
            TelefonoCelular: telefonoCelularValue,
            Ciudad: ciudadValue,
            Barrio: barrioValue,
            Direccion: direccionValue,
            CodigoPostal: codigoPostalValue,
            TelefonoEmpresa: telefonoEmpresaValue,
            Sucursales: sucursalesValue,
            DireccionSucursales: direccionSucursalesValue,
            InstitucionFinancieraoEntidad: instFinancieraValue,
            EntidadDeposito: entidadDepositoValue,
            AccionesCotizan: entidadAccionesValue,
            NombreMercado: nombreMercadoValue,
            EntidadGubernamental: entidadGubernamentalValue,
            EntidadPasiva: entidadPasivaValue,
            NPersonasEjercen: nPersonasEjercen,
            PersonaEjerce1: personasEjercen1Value,
            PersonaEjerce2: personasEjercen2Value,
            PersonaEjerce3: personasEjercen3Value,
            EsSociedadEU: isEuValue,
            SNN: identificacionContibuyenteSnnValue,
            ResidenteOtroPais: isNoEuValue,
            CuantosPaises: cuantosPaisesNoEuValue,
            PaisResidente1: paisResidente1,
            PaisResidente1SNN: paisResidente1SNN,
            PaisResidente2: paisResidente2,
            PaisResidente2SNN: paisResidente2SNN,
            PaisResidente3: paisResidente3,
            PaisResidente3SNN: paisResidente3SNN,
            CajaBanco: cajaBancosValue,
            CuentasXCobrar: cuentasPorCobrarValue,
            ActivosFijos: activosFijosValue,
            ValorInversion: valorInversionesValue,
            OtrosActivos: otrosActivosValue,
            TotalActivos: totalActivosValue,
            IngresosMensuales: ingresosMensualesValue,
            CuentasXPagar: cuentasPorPagarValue,
            ObligacionesFinancieras: obligacionesFinancierasValue,
            OtrosPasivos: otrosPasivosValue,
            TotalPasivos: totalPasivosValue,
            Patrimonio: patrimonioValue,
            EgresosMensuales: egresosMensualesValue,
            NCuentas: nCuentasValue,
            InstitucionFinancieraCuenta1: institucionFinanciera1Value,
            TipoDeCuenta1: tipoCuentaValue,
            NumeroDeCuenta1: numeroCuenta1Value,
            InstitucionFinancieraCuenta2: institucionFinanciera2Value,
            TipoDeCuenta2: tipoCuenta2Value,
            NumeroDeCuenta2: numeroCuenta2Value,
            ObjetoDeInversion: objetoInversionValue,
            NecesidadDeLiquidez: necesidadLiquidezValue,
            Experiencia: experienciaValue,
            PlazoDeInversion: plazoInversionValue,
            DisponibilidadRecursos: disponibilidadRecursosValue,
            Firma: fileData[0],
            NombreCompletoFirmante: nombreCompletoFirmanteValue,
            CedulaPasaporteFirmante: cedulaPasaporteFirmanteValue,
            CopiaCedulaRepresentante: fileData[1],
            CopiaPapeletaRepresentante: fileData[2],
            CopiaPlanilla: fileData[3],
            CopiaNombramiento: fileData[4],
            CopiaRUC: fileData[5],
            CopiaEscrituraConstitucion: fileData[6],
            CopiaEstatutosSociales: fileData[7],
            CopiaCertificadoBancario: fileData[8],
            CopiaEstadosFinancieros: fileData[9],
            CopiaNominaAccionistas: fileData[10],
            CopiaCertificadoCumplimiento: fileData[11],
            CopiaDeclaracionSRI: fileData[12],
            FechaDeEnvio: new Date(),
            Tag: "Clientes",
          })
          .then(() => {
            setJuridicalPersonForm({
              EsEmisor: isEmisor,
              CargoPublico: isCargoPublicoValue,
              FamiliarCargoPublico: isFamiliarCargoPublicoValue,
              TrabajaCargoPublico: isTrabajaCargoPublicoValue,
              DireccionRepresentante: direccionRepresentanteValue,
              CorreoRepresentante: correoRepresentanteValue,
              RazonSocial: razonSocialValue,
              NombreComercial: nombreComercialValue,
              RUC: rucValue,
              Email: emailValue,
              ActividadEconomica: actividadValue,
              Nombres: nombresValue,
              Apellidos: apellidosValue,
              CIPasaporte: ciPasaporteValue,
              Nacionalidad: nacionalidadValue,
              FechaNacimiento: fechaNacimientoValue,
              EstadoCivil: estCivilValue,
              TelefonoDomicilio: telefonoDomicilioValue,
              TelefonoCelular: telefonoCelularValue,
              Ciudad: ciudadValue,
              Barrio: barrioValue,
              Direccion: direccionValue,
              CodigoPostal: codigoPostalValue,
              TelefonoEmpresa: telefonoEmpresaValue,
              Sucursales: sucursalesValue,
              DireccionSucursales: direccionSucursalesValue,
              InstitucionFinancieraoEntidad: instFinancieraValue,
              EntidadDeposito: entidadDepositoValue,
              AccionesCotizan: entidadAccionesValue,
              NombreMercado: nombreMercadoValue,
              EntidadGubernamental: entidadGubernamentalValue,
              EntidadPasiva: entidadPasivaValue,
              NPersonasEjercen: nPersonasEjercen,
              PersonaEjerce1: personasEjercen1Value,
              PersonaEjerce2: personasEjercen2Value,
              PersonaEjerce3: personasEjercen3Value,
              EsSociedadEU: isEuValue,
              SNN: identificacionContibuyenteSnnValue,
              ResidenteOtroPais: isNoEuValue,
              CuantosPaises: cuantosPaisesNoEuValue,
              PaisResidente1: paisResidente1,
              PaisResidente1SNN: paisResidente1SNN,
              PaisResidente2: paisResidente2,
              PaisResidente2SNN: paisResidente2SNN,
              PaisResidente3: paisResidente3,
              PaisResidente3SNN: paisResidente3SNN,
              CajaBanco: cajaBancosValue,
              CuentasXCobrar: cuentasPorCobrarValue,
              ActivosFijos: activosFijosValue,
              ValorInversion: valorInversionesValue,
              OtrosActivos: otrosActivosValue,
              TotalActivos: totalActivosValue,
              IngresosMensuales: ingresosMensualesValue,
              CuentasXPagar: cuentasPorPagarValue,
              ObligacionesFinancieras: obligacionesFinancierasValue,
              OtrosPasivos: otrosPasivosValue,
              TotalPasivos: totalPasivosValue,
              Patrimonio: patrimonioValue,
              EgresosMensuales: egresosMensualesValue,
              NCuentas: nCuentasValue,
              InstitucionFinancieraCuenta1: institucionFinanciera1Value,
              TipoDeCuenta1: tipoCuentaValue,
              NumeroDeCuenta1: numeroCuenta1Value,
              InstitucionFinancieraCuenta2: institucionFinanciera2Value,
              TipoDeCuenta2: tipoCuenta2Value,
              NumeroDeCuenta2: numeroCuenta2Value,
              ObjetoDeInversion: objetoInversionValue,
              NecesidadDeLiquidez: necesidadLiquidezValue,
              Experiencia: experienciaValue,
              PlazoDeInversion: plazoInversionValue,
              DisponibilidadRecursos: disponibilidadRecursosValue,
              Firma: fileData[0],
              NombreCompletoFirmante: nombreCompletoFirmanteValue,
              CedulaPasaporteFirmante: cedulaPasaporteFirmanteValue,
              CopiaCedulaRepresentante: fileData[1],
              CopiaPapeletaRepresentante: fileData[2],
              CopiaPlanilla: fileData[3],
              CopiaNombramiento: fileData[4],
              CopiaRUC: fileData[5],
              CopiaEscrituraConstitucion: fileData[6],
              CopiaEstatutosSociales: fileData[7],
              CopiaCertificadoBancario: fileData[8],
              CopiaEstadosFinancieros: fileData[9],
              CopiaNominaAccionistas: fileData[10],
              CopiaCertificadoCumplimiento: fileData[11],
              CopiaDeclaracionSRI: fileData[12],
              FechaDeEnvio: new Date(),
            });
            setIsLoading(false);
            setIsDeviveringToDB(true);
            setTimeout(() => {
              window.location.href = "www.fiduvalor.com.ec";
            }, 3000);
          })
          .catch(() => {
            alert("Se ha producido un error. Inténtelo más tarde.");
          });
      });
  };

  //Send Email

  const sendEmailForm = () => {
    emailjs
      .send(
        "service_5ubgeq3",
        "template_fk649lb",
        juridicalPersonForm,
        "8a6YjyUTerawhlWGO"
      )
      .then(
        function (response) {
          console.log("SUCCESS!", response.status, response.text);
        },
        function (error) {
          console.log("FAILED...", error);
        }
      );
  };

  useEffect(() => {
    isDeliveringToDB && sendEmailForm();
  }, [isDeliveringToDB]);

  //Signature pad
  const [imageURL, setImageURL] = useState(null); // create a state that will contain our image url

  const sigCanvas = useRef({});

  /* a function that uses the canvas ref to clear the canvas 
  via a method given by react-signature-canvas */
  const clear = () => {
    sigCanvas.current.clear();
  };

  const deleteSignature = () => {
    setImageURL(null);
    setDisableIfMadeSignature(false);
  };

  /* a function that uses the canvas ref to trim the canvas 
  from white spaces via a method given by react-signature-canvas
  then saves it in our state */
  const save = () => {
    setImageURL(sigCanvas.current.getTrimmedCanvas().toDataURL("image/png"));
    setDisableIfMadeSignature(true);
  };

  const firstRender = useRef(true);

  const [disableIfUploadSignature, setDisableIfUploadSignature] =
    useState(false);

  const [disableIfMadeSignature, setDisableIfMadeSignature] = useState(false);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
    } else {
      if (firmaFileValue.length === 0) {
        setDisableIfUploadSignature(false);
      } else {
        setDisableIfUploadSignature(true);
      }
    }
  }, [firmaFileValue]);

  //VALIDATIONS
  const validationSchema = Yup.object().shape({
    razonsocial: Yup.string().required("Necesita Completar Este Campo"),
    nombrecomercial: Yup.string().required("Necesita Completar Este Campo"),
    ruc: Yup.string().required("Necesita Completar Este Campo"),
    email: Yup.string()
      .required("Necesita Completar Este Campo")
      .email("No es un correo válido"),
    actividadeconomica: Yup.string().required("Necesita Completar Este Campo"),
    nombres: Yup.string().required("Necesita Completar Este Campo"),
    apellidos: Yup.string().required("Necesita Completar Este Campo"),
    ccpasaporte: Yup.string().required("Necesita Completar Este Campo"),
    nacionalidad: Yup.string().required("Necesita Completar Este Campo"),
    estcivil: Yup.string().required("Necesita Completar Este Campo"),
    telefonodomicilio: Yup.string().required("Necesita Completar Este Campo"),
    telefonocelular: Yup.string().required("Necesita Completar Este Campo"),
    direccionrepresentante: Yup.string().required(
      "Necesita Completar Este Campo"
    ),
    correorepresentante: Yup.string().required("Necesita Completar Este Campo"),
    ciudad: Yup.string().required("Necesita Completar Este Campo"),
    barrio: Yup.string().required("Necesita Completar Este Campo"),
    direccion: Yup.string().required("Necesita Completar Este Campo"),
    telefonoempresa: Yup.string().required("Necesita Completar Este Campo"),
    sucursales: Yup.string().required("Necesita Completar Este Campo"),
    direccionsucursales: Yup.string().required("Necesita Completar Este Campo"),
    instfinanciera: Yup.string().required("Necesita Completar Este Campo"),
    entidaddeposito: Yup.string().required("Necesita Completar Este Campo"),
    entidadacciones: Yup.string().required("Necesita Completar Este Campo"),
    entidadgubernamental: Yup.string().required(
      "Necesita Completar Este Campo"
    ),
    entidadpasiva: Yup.string().required("Necesita Completar Este Campo"),
    npersonasejercen: Yup.string().required("Necesita Completar Este Campo"),
    iseu: Yup.string().required("Necesita Completar Este Campo"),
    cajabanco: Yup.string().required("Necesita Completar Este Campo"),
    cuentasxcobrar: Yup.string().required("Necesita Completar Este Campo"),
    activosfijos: Yup.string().required("Necesita Completar Este Campo"),
    valorinversion: Yup.string().required("Necesita Completar Este Campo"),
    otrosactivos: Yup.string().required("Necesita Completar Este Campo"),
    ingresosmensuales: Yup.string().required("Necesita Completar Este Campo"),
    cuentasporpagar: Yup.string().required("Necesita Completar Este Campo"),
    obligacionesfinancieras: Yup.string().required(
      "Necesita Completar Este Campo"
    ),
    otrospasivos: Yup.string().required("Necesita Completar Este Campo"),
    egresosmensuales: Yup.string().required("Necesita Completar Este Campo"),
    ncuentas: Yup.string().required("Necesita Completar Este Campo"),
    objinversion: Yup.string().required("Necesita Completar Este Campo"),
    necesidadliquidez: Yup.string().required("Necesita Completar Este Campo"),
    experiencia: Yup.string().required("Necesita Completar Este Campo"),
    plazoinversion: Yup.string().required("Necesita Completar Este Campo"),
    disponibilidadrecursos: Yup.string().required(
      "Necesita Completar Este Campo"
    ),
    nfirmante: Yup.string().required("Necesita Completar Este Campo"),
    cifirmante: Yup.string().required("Necesita Completar Este Campo"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = () => {
    setIsLoading(true);
    setUpload(true);
  };

  const firstRenderUpload = useRef(true);

  const [upload, setUpload] = useState(false);

  useEffect(() => {
    if (firstRenderUpload.current) {
      firstRenderUpload.current = false;
    } else {
      if (upload) {
        uploadAll();
      }
    }
  }, [upload]);

  const [progress, setProgress] = useState(0);

  return (
    <MainContainer style={{ display: onItemClickBack && "none" }}>
      {/* Title and Descriptio */}
      <TitleFormContainer>
        <TitleForm>FORMULARIO</TitleForm>
        <FormDescription>
          Completa el siguiente formulario {"\n"} con los datos de su empresa
        </FormDescription>
      </TitleFormContainer>
      <form name="form" id="form" onSubmit={handleSubmit(onSubmit)}>
        <SectionContainer1Column>
        <Divider/>
          <div>
            <FormControlLabel
              control={
                <Checkbox
                  value={isEmisor}
                  onChange={() => {
                    setIsEmisor(!isEmisor);
                  }}
                />
              }
              label="¿Es usted un Emisor?"
            />
          </div>
        </SectionContainer1Column>
        {/************* DATOS GENERALES *****************/}
        <TitleSection>
          Datos Generales
          <Divider />
        </TitleSection>
        <SectionContainer3Columns>
          <div>
            <TextField
              autoComplete="new-password"
              name="razonsocial"
              style={{ width: "100%" }}
              id="outlined-required"
              label="Razón Social"
              {...register("razonsocial")}
              error={errors.razonsocial ? true : false}
              onBlur={onRazonSocialChange}
            />
            <Typography variant="inherit" color="red">
              {errors.razonsocial?.message}
            </Typography>
          </div>
          <div>
            <TextField
              autoComplete="new-password"
              name="nombrecomercial"
              style={{ width: "100%" }}
              id="outlined-required"
              label="Nombre Comercial"
              {...register("nombrecomercial")}
              error={errors.nombrecomercial ? true : false}
              onBlur={onNombreComercialChange}
            />
            <Typography variant="inherit" color="red">
              {errors.nombrecomercial?.message}
            </Typography>
          </div>
          <div>
            <TextField
              autoComplete="new-password"
              name="ruc"
              style={{ width: "100%" }}
              id="outlined-required"
              label="Registro Único de Contribuyentes"
              {...register("ruc")}
              error={errors.ruc ? true : false}
              onBlur={onRucChange}
            />
            <Typography variant="inherit" color="red">
              {errors.ruc?.message}
            </Typography>
          </div>
          <div>
            <TextField
              autoComplete="new-password"
              name="email"
              style={{ width: "100%" }}
              id="outlined-required"
              label="Correo Electrónico"
              {...register("email")}
              error={errors.email ? true : false}
              onBlur={onEmailChange}
            />
            <Typography variant="inherit" color="red">
              {errors.email?.message}
            </Typography>
          </div>
          <div>
            <TextField
              autoComplete="new-password"
              name="actividadeconomica"
              style={{ width: "100%" }}
              id="outlined-required"
              label="Actividad Económica"
              {...register("actividadeconomica")}
              error={errors.actividadeconomica ? true : false}
              onBlur={onActividadEconomicaChange}
            />
            <Typography variant="inherit" color="red">
              {errors.actividadeconomica?.message}
            </Typography>
          </div>
        </SectionContainer3Columns>
        {/************* DATOS REPRESENTANTE LEGAL *****************/}
        <TitleSection>
          Datos de Representante Legal
          <Divider />
        </TitleSection>
        <SectionContainer3Columns>
          <div>
            <TextField
              autoComplete="new-password"
              name="nombres"
              style={{ width: "100%" }}
              id="outlined-required"
              label="Nombres"
              {...register("nombres")}
              error={errors.nombres ? true : false}
              onBlur={onNombresChange}
            />
            <Typography variant="inherit" color="red">
              {errors.nombres?.message}
            </Typography>
          </div>
          <div>
            <TextField
              autoComplete="new-password"
              name="apellidos"
              style={{ width: "100%" }}
              id="outlined-required"
              label="Apellidos"
              {...register("apellidos")}
              error={errors.apellidos ? true : false}
              onBlur={onApellidosChange}
            />
            <Typography variant="inherit" color="red">
              {errors.apellidos?.message}
            </Typography>
          </div>
          <div>
            <TextField
              autoComplete="new-password"
              name="ccpasaporte"
              style={{ width: "100%" }}
              id="outlined-required"
              label="C.C / Pasaporte"
              {...register("ccpasaporte")}
              error={errors.ccpasaporte ? true : false}
              onBlur={onCiPasaporteChange}
            />
            <Typography variant="inherit" color="red">
              {errors.ccpasaporte?.message}
            </Typography>
          </div>
          <div>
            <TextField
              autoComplete="new-password"
              name="nacionalidad"
              style={{ width: "100%" }}
              id="outlined-required"
              label="Nacionalidad"
              {...register("nacionalidad")}
              error={errors.nacionalidad ? true : false}
              onBlur={onNacionalidadChange}
            />
            <Typography variant="inherit" color="red">
              {errors.nacionalidad?.message}
            </Typography>
          </div>
          <LocalizationProvider dateAdapter={AdapterDayjs} locale={es}>
            <DatePicker
              inputFormat="dd/MM/yyyy"
              disableFuture
              label="Fecha de Nacimiento"
              value={fechaNacimientoValue}
              onChange={(newValue) => {
                let fecha = new Date(newValue);
                setFechaNacimientoValue(fecha);
              }}
              renderInput={(params) => (
                <TextField
                  style={{ width: "100%" }}
                  {...params}
                  name="fnacimiento"
                />
              )}
            />
          </LocalizationProvider>
          <div>
            <FormControl style={{ width: "100%" }}>
              <InputLabel id="demo-simple-select-label">
                Estado Civil
              </InputLabel>
              <Select
                style={{ width: "100%" }}
                name="estcivil"
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="Estado Civil"
                MenuProps={{ disableScrollLock: true }}
                {...register("estcivil")}
                error={errors.estcivil ? true : false}
                value={estCivilValue}
                onChange={onEstCivilChange}
              >
                <MenuItem value="Soltero/a">Soltero/a</MenuItem>
                <MenuItem value="Casado/a">Casado/a</MenuItem>
                <MenuItem value="Divorciado/a">Divorciado/a</MenuItem>
                <MenuItem value="Viudo/a">Viudo/a</MenuItem>
              </Select>
            </FormControl>

            <Typography variant="inherit" color="red">
              {errors.estcivil?.message}
            </Typography>
          </div>
          <div>
            <TextField
              autoComplete="new-password"
              name="telefonodomicilio"
              style={{ width: "100%" }}
              id="outlined-required"
              label="Teléfono de Domicilio"
              {...register("telefonodomicilio")}
              error={errors.telefonodomicilio ? true : false}
              onBlur={onTelefonoDomicilioChange}
            />
            <Typography variant="inherit" color="red">
              {errors.telefonodomicilio?.message}
            </Typography>
          </div>
          <div>
            <TextField
              autoComplete="new-password"
              name="telefonocelular"
              style={{ width: "100%" }}
              id="outlined-required"
              label="Teléfono de Celular"
              {...register("telefonocelular")}
              error={errors.telefonocelular ? true : false}
              onBlur={onTelefonoCelularChange}
            />
            <Typography variant="inherit" color="red">
              {errors.telefonocelular?.message}
            </Typography>
          </div>
          <div>
            <TextField
              autoComplete="new-password"
              name="direccionrepresentante"
              style={{ width: "100%" }}
              id="outlined-required"
              label="Dirección"
              {...register("direccionrepresentante")}
              error={errors.direccion ? true : false}
              onBlur={onDireccionRepresentanteChange}
            />
            <Typography variant="inherit" color="red">
              {errors.direccionrepresentante?.message}
            </Typography>
          </div>
          <div>
            <TextField
              autoComplete="new-password"
              name="correorepresentante"
              style={{ width: "100%" }}
              id="outlined-required"
              label="Correo Electrónico"
              {...register("correorepresentante")}
              error={errors.correorepresentante ? true : false}
              onBlur={onCorreoRepresentanteChange}
            />
            <Typography variant="inherit" color="red">
              {errors.correorepresentante?.message}
            </Typography>
          </div>
        </SectionContainer3Columns>
        {/************* INFORMACIÓN DE LA EMPRESA *****************/}
        <TitleSection>
          Información de la Empresa
          <Divider />
        </TitleSection>
        <SectionContainer3Columns>
          <div>
            <TextField
              autoComplete="new-password"
              name="ciudad"
              style={{ width: "100%" }}
              id="outlined-required"
              label="Ciudad"
              {...register("ciudad")}
              error={errors.ciudad ? true : false}
              onBlur={onCiudadChange}
            />
            <Typography variant="inherit" color="red">
              {errors.ciudad?.message}
            </Typography>
          </div>
          <div>
            <TextField
              autoComplete="new-password"
              name="barrio"
              style={{ width: "100%" }}
              id="outlined-required"
              label="Barrio"
              {...register("barrio")}
              error={errors.barrio ? true : false}
              onBlur={onBarrioChange}
            />
            <Typography variant="inherit" color="red">
              {errors.barrio?.message}
            </Typography>
          </div>
          <div>
            <TextField
              autoComplete="new-password"
              name="direccion"
              style={{ width: "100%" }}
              id="outlined-required"
              label="Dirección"
              {...register("direccion")}
              error={errors.direccion ? true : false}
              onBlur={onDireccionChange}
            />
            <Typography variant="inherit" color="red">
              {errors.direccion?.message}
            </Typography>
          </div>
          <div>
            <TextField
              autoComplete="new-password"
              name="codigopostal"
              style={{ width: "100%" }}
              id="outlined-required"
              label="Código Postal"
              {...register("codigopostal")}
              onBlur={onCodigoPostalChange}
            />
          </div>
          <div>
            <TextField
              autoComplete="new-password"
              name="telefonoempresa"
              style={{ width: "100%" }}
              id="outlined-required"
              label="Teléfono"
              {...register("telefonoempresa")}
              error={errors.telefonoempresa ? true : false}
              onBlur={onTelefonoEmpresaChange}
            />
            <Typography variant="inherit" color="red">
              {errors.telefonoempresa?.message}
            </Typography>
          </div>
          <div>
            <TextField
              autoComplete="new-password"
              name="sucursales"
              style={{ width: "100%" }}
              id="outlined-required"
              label="Sucursales"
              {...register("sucursales")}
              error={errors.sucursales ? true : false}
              onBlur={onSucursalesChange}
            />
            <Typography variant="inherit" color="red">
              {errors.sucursales?.message}
            </Typography>
          </div>
          <div>
            <TextField
              autoComplete="new-password"
              name="direccionsucursales"
              style={{ width: "100%" }}
              id="outlined-required"
              label="Dirección de Sucursales"
              {...register("direccionsucursales")}
              error={errors.direccionsucursales ? true : false}
              onBlur={onDireccionSucursalesChange}
            />
            <Typography variant="inherit" color="red">
              {errors.direccionsucursales?.message}
            </Typography>
          </div>
        </SectionContainer3Columns>
        {/************* PERSONA QUE EJERCE EL CONTROL *****************/}
        <TitleSection>
          Persona que ejerce el control
          <Divider />
        </TitleSection>
        <SectionContainer1Column>
          <div>
            <FormControl style={{ width: "100%" }}>
              <InputLabel id="demo-simple-select-label">
                ¿Es una institución financiera o entidad de inversión?
              </InputLabel>
              <Select
                style={{ width: "100%" }}
                name="instfinanciera"
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="¿Es una institución financiera o entidad de inversión?"
                MenuProps={{ disableScrollLock: true }}
                {...register("instfinanciera")}
                error={errors.instfinanciera ? true : false}
                value={instFinancieraValue}
                onChange={onInstFinancieraChange}
              >
                <MenuItem value="Si">Si</MenuItem>
                <MenuItem value="No">No</MenuItem>
              </Select>
            </FormControl>
            <Typography variant="inherit" color="red">
              {errors.instfinanciera?.message}
            </Typography>
          </div>
          <div>
            <FormControl style={{ width: "100%" }}>
              <InputLabel id="demo-simple-select-label">
                ¿Es una entidad de depósito, custodia, o compañía de seguros?
              </InputLabel>
              <Select
                style={{ width: "100%" }}
                name="entidaddeposito"
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="¿Es una entidad de depósito, custodia, o compañía de seguros?"
                MenuProps={{ disableScrollLock: true }}
                {...register("entidaddeposito")}
                error={errors.entidaddeposito ? true : false}
                value={entidadDepositoValue}
                onChange={onEntidadDepositoChange}
              >
                <MenuItem value="Si">Si</MenuItem>
                <MenuItem value="No">No</MenuItem>
              </Select>
            </FormControl>
            <Typography variant="inherit" color="red">
              {errors.entidaddeposito?.message}
            </Typography>
            {isEntidadDeposito && (
              <Alert severity="warning">
                Debe completar el formulario de auto-certificación de persona
                natural
              </Alert>
            )}
          </div>
          <div>
            <FormControl style={{ width: "100%" }}>
              <InputLabel id="demo-simple-select-label">
                ¿Es una entidad cuyas acciones se cotizan en bolsa?
              </InputLabel>
              <Select
                style={{ width: "100%" }}
                name="entidadacciones"
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="¿Es una entidad cuyas acciones se cotizan en bolsa?"
                MenuProps={{ disableScrollLock: true }}
                {...register("entidadacciones")}
                error={errors.entidadacciones ? true : false}
                value={entidadAccionesValue}
                onChange={onEntidadAccionesChange}
              >
                <MenuItem value="Si">Si</MenuItem>
                <MenuItem value="No">No</MenuItem>
              </Select>
            </FormControl>
            <Typography variant="inherit" color="red">
              {errors.entidadacciones?.message}
            </Typography>
            {isEntidadAcciones && (
              <>
                <p>{"\n"}</p>
                <TextField
                  autoComplete="new-password"
                  name="nombremercado"
                  style={{ width: "100%" }}
                  id="outlined-required"
                  label="Nombre del mercado en donde se cotiza"
                  {...register("nombremercado")}
                  onBlur={onNombreMercadoChange}
                />
              </>
            )}
          </div>
          <div>
            <FormControl style={{ width: "100%" }}>
              <InputLabel id="demo-simple-select-label">
                ¿Es una entidad gubernamental u organismo internacional?
              </InputLabel>
              <Select
                style={{ width: "100%" }}
                name="entidadgubernamental"
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="¿Es una entidad gubernamental u organismo internacional?"
                MenuProps={{ disableScrollLock: true }}
                {...register("entidadgubernamental")}
                error={errors.entidadgubernamental ? true : false}
                value={entidadGubernamentalValue}
                onChange={onEntidadGubernamentalChange}
              >
                <MenuItem value="Si">Si</MenuItem>
                <MenuItem value="No">No</MenuItem>
              </Select>
            </FormControl>
            <Typography variant="inherit" color="red">
              {errors.entidadgubernamental?.message}
            </Typography>
          </div>
          <div>
            <FormControl style={{ width: "100%" }}>
              <InputLabel id="demo-simple-select-label">
                ¿Es una entidad no financiera pasiva?
              </InputLabel>
              <Select
                style={{ width: "100%" }}
                name="entidadpasiva"
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="¿Es una entidad no financiera pasiva?"
                MenuProps={{ disableScrollLock: true }}
                {...register("entidadpasiva")}
                error={errors.entidadpasiva ? true : false}
                value={entidadPasivaValue}
                onChange={onEntidadPasivaChange}
              >
                <MenuItem value="Si">Si</MenuItem>
                <MenuItem value="No">No</MenuItem>
              </Select>
            </FormControl>
            <Typography variant="inherit" color="red">
              {errors.entidadpasiva?.message}
            </Typography>
            {isEntidadPasiva && (
              <Alert severity="warning">
                Debe completar el formulario de auto-certificación de persona
                natural
              </Alert>
            )}
          </div>
          <div>
            <FormControl style={{ width: "100%" }}>
              <InputLabel id="demo-simple-select-label">
                ¿Cuántas personas ejercen el control sobre la sociedad titular?
              </InputLabel>
              <Select
                style={{ width: "100%" }}
                name="npersonasejercen"
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="¿Cuántas personas ejercen el control sobre la sociedad titular?"
                MenuProps={{ disableScrollLock: true }}
                {...register("npersonasejercen")}
                error={errors.npersonasejercen ? true : false}
                value={nPersonasEjercen}
                onChange={onNPersonasEjercen}
              >
                <MenuItem value="1">1</MenuItem>
                <MenuItem value="2">2</MenuItem>
                <MenuItem value="3">3</MenuItem>
              </Select>
            </FormControl>
            <Typography variant="inherit" color="red">
              {errors.npersonasejercen?.message}
            </Typography>
            {isNPersonasEjercen1 && (
              <>
                <Alert severity="warning">
                  Por cada una de estas personas llene una auto-certificación de
                  persona natural
                </Alert>
                <p>{"\n"}</p>

                <TextField
                  autoComplete="new-password"
                  name="npersonasejercen1"
                  style={{ width: "100%" }}
                  id="outlined-required"
                  label="Nombre Completo"
                  {...register("npersonasejercen1")}
                  onBlur={onPersonasEjercen1Change}
                />
              </>
            )}
            {isNPersonasEjercen2 && (
              <>
                <Alert severity="warning">
                  Por cada una de estas personas llene una auto-certificación de
                  persona natural
                </Alert>
                <p>{"\n"}</p>

                <TextField
                  autoComplete="new-password"
                  name="npersonasejercen1"
                  style={{ width: "100%" }}
                  id="outlined-required"
                  label="Nombre Completo"
                  {...register("npersonasejercen1")}
                  onBlur={onPersonasEjercen1Change}
                />
                <p>{"\n"}</p>
                <TextField
                  autoComplete="new-password"
                  name="npersonasejercen2"
                  style={{ width: "100%" }}
                  id="outlined-required"
                  label="Nombre Completo"
                  {...register("npersonasejercen2")}
                  onBlur={onPersonasEjercen2Change}
                />
              </>
            )}

            {isNPersonasEjercen3 && (
              <>
                <Alert severity="warning">
                  Por cada una de estas personas llene una auto-certificación de
                  persona natural
                </Alert>
                <p>{"\n"}</p>
                <TextField
                  autoComplete="new-password"
                  name="npersonasejercen1"
                  style={{ width: "100%" }}
                  id="outlined-required"
                  label="Nombre Completo"
                  {...register("npersonasejercen1")}
                  onBlur={onPersonasEjercen1Change}
                />
                <p>{"\n"}</p>
                <TextField
                  autoComplete="new-password"
                  name="npersonasejercen2"
                  style={{ width: "100%" }}
                  id="outlined-required"
                  label="Nombre Completo"
                  {...register("npersonasejercen2")}
                  onBlur={onPersonasEjercen2Change}
                />
                <p>{"\n"}</p>
                <TextField
                  autoComplete="new-password"
                  name="npersonasejercen3"
                  style={{ width: "100%" }}
                  id="outlined-required"
                  label="Nombre Completo"
                  {...register("npersonasejercen3")}
                  onBlur={onPersonasEjercen3Change}
                />
              </>
            )}
          </div>
        </SectionContainer1Column>
        <TitleSection>
          Personas Expuestas Políticamente (PEP)
          <Divider />
        </TitleSection>
        <SectionContainer1Column>
          <FormControl style={{ width: "100%" }}>
            <InputLabel id="demo-simple-select-label">
              Usted, desempeña o ha desempeñado funciones o cargos públicos en
              el Ecuador o en el extranjero
            </InputLabel>
            <Select
              style={{ width: "100%" }}
              name="isCargoPublico"
              label="Usted, desempeña o ha desempeñado funciones o cargos públicos en el Ecuador o en el extranjero"
              MenuProps={{ disableScrollLock: true }}
              {...register("isCargoPublico")}
              value={isCargoPublicoValue}
              onChange={onIsCargoPublicoChange}
            >
              <MenuItem value="Si">Si</MenuItem>
              <MenuItem value="No">No</MenuItem>
            </Select>
          </FormControl>
          <FormControl style={{ width: "100%" }}>
            <InputLabel id="demo-simple-select-label">
              Usted es familiar de un PEP, en el 2do grado de consanguinidad
              (padres/hijos/abuelos/nietos/cónyuge){" "}
            </InputLabel>
            <Select
              style={{ width: "100%" }}
              name="isFamiliarCargoPublico"
              label="Usted es familiar de un PEP, en el 2do grado de consanguinidad (padres/hijos/abuelos/nietos/cónyuge)"
              MenuProps={{ disableScrollLock: true }}
              {...register("isFamiliarCargoPublico")}
              value={isFamiliarCargoPublicoValue}
              onChange={onIsFamiliarCargoPublicoChange}
            >
              <MenuItem value="Si">Si</MenuItem>
              <MenuItem value="No">No</MenuItem>
            </Select>
          </FormControl>
          <FormControl style={{ width: "100%" }}>
            <InputLabel id="demo-simple-select-label">
              Usted trabaja políticamente con una personas expuesta
              políticamente (PEP){" "}
            </InputLabel>
            <Select
              style={{ width: "100%" }}
              name="isTrabajaCargoPublico"
              label="Usted trabaja políticamente con una personas expuesta políticamente (PEP) "
              MenuProps={{ disableScrollLock: true }}
              {...register("isTrabajaCargoPublico")}
              value={isTrabajaCargoPublicoValue}
              onChange={onIsTrabajaCargoPublicoValueChange}
            >
              <MenuItem value="Si">Si</MenuItem>
              <MenuItem value="No">No</MenuItem>
            </Select>
          </FormControl>
          <Typography>
            <strong> Nota: </strong>
            Si usted respondió si a una de las preguntas anteriores se le
            enviará el formulario PEP para que lo complete correctamente. Forma
            parte de nuestras políticas que las personas políticamente expuestas
            o relacionadas con ellas llenen este formulario.
          </Typography>
        </SectionContainer1Column>
        {/************* RESIDENCIA FISCAL *****************/}
        <TitleSection>
          Residencia Fiscal
          <Divider />
        </TitleSection>
        <SectionContainer1Column>
          <div>
            <FormControl style={{ width: "100%" }}>
              <InputLabel id="demo-simple-select-label">
                ¿Es una sociedad estadounidense para fines fiscales?{" "}
              </InputLabel>
              <Select
                style={{ width: "100%" }}
                name="iseu"
                labelId="demo-simple-select-label"
                id="demo-simple-select-helper"
                label="¿Es una sociedad estadounidense para fines fiscales? "
                MenuProps={{ disableScrollLock: true }}
                {...register("iseu")}
                value={isEuValue}
                onChange={onIsEuValueChange}
              >
                <MenuItem value="Si">Si</MenuItem>
                <MenuItem value="No">No</MenuItem>
              </Select>
            </FormControl>
            <Typography variant="inherit" color="red">
              {errors.iseu?.message}
            </Typography>
          </div>
          {isEu ? (
            <TextField
              autoComplete="new-password"
              name="snn"
              style={{ width: "100%" }}
              id="outlined-required"
              label="Identificación del Contribuyente en SSN"
              {...register("snn")}
              onBlur={onIdentificacionContribuyenteSnnChange}
            />
          ) : (
            <>
              <div>
                <FormControl style={{ width: "100%" }}>
                  <InputLabel id="demo-simple-select-label">
                    ¿La Sociedad es residente de cualquier otro país distinto de
                    Estados Unidos para fines fiscales?
                  </InputLabel>
                  <Select
                    style={{ width: "100%" }}
                    name="isnoeu"
                    labelId="demo-simple-select-label"
                    id="demo-simple-select-helper"
                    label="¿La Sociedad es residente de cualquier otro país distinto de
                Estados Unidos para fines fiscales?"
                    MenuProps={{ disableScrollLock: true }}
                    {...register("isnoeu")}
                    value={isNoEuValue}
                    onChange={onIsNoEuChange}
                  >
                    <MenuItem value="Si">Si</MenuItem>
                    <MenuItem value="No">No</MenuItem>
                  </Select>
                </FormControl>
              </div>
              <SectionContainer1Column style={{ marginLeft: "0px" }}>
                {isNoEu && (
                  <div>
                    <FormControl style={{ width: "100%" }}>
                      <InputLabel id="demo-simple-select-label">
                        ¿Cuántos paises?
                      </InputLabel>
                      <Select
                        style={{ width: "50%" }}
                        name="cuantospaises"
                        labelId="demo-simple-select-label"
                        id="demo-simple-select-helper"
                        label="¿Cuántos paises?"
                        MenuProps={{ disableScrollLock: true }}
                        {...register("cuantospaises")}
                        value={cuantosPaisesNoEuValue}
                        onChange={onCuantosPaisesNoEuChange}
                      >
                        <MenuItem value="1">1</MenuItem>
                        <MenuItem value="2">2</MenuItem>
                        <MenuItem value="3">3</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                )}
                {isPais1 && (
                  <SectionContainer2Columns style={{ marginLeft: "0px" }}>
                    <div>
                      <TextField
                        autoComplete="new-password"
                        name="paisresidente1"
                        style={{ width: "100%" }}
                        id="outlined-required"
                        label="Pais Residente"
                        {...register("paisresidente1")}
                        onBlur={onPaisResidente1}
                      />
                    </div>
                    <div>
                      <TextField
                        autoComplete="new-password"
                        name="paisresidente1snn"
                        style={{ width: "100%" }}
                        id="outlined-required"
                        label="Identificación del contribuyente en SNN"
                        {...register("paisresidente1snn")}
                        onBlur={onPaisResidente1SNN}
                      />
                    </div>
                  </SectionContainer2Columns>
                )}
                {isPais2 && (
                  <SectionContainer2Columns style={{ marginLeft: "0px" }}>
                    <div>
                      <TextField
                        autoComplete="new-password"
                        name="paisresidente1"
                        style={{ width: "100%" }}
                        id="outlined-required"
                        label="Pais Residente"
                        {...register("paisresidente1")}
                        onBlur={onPaisResidente1}
                      />
                    </div>
                    <div>
                      <TextField
                        autoComplete="new-password"
                        name="paisresidente1snn"
                        style={{ width: "100%" }}
                        id="outlined-required"
                        label="Identificación del contribuyente en SNN"
                        {...register("paisresidente1snn")}
                        onBlur={onPaisResidente1SNN}
                      />
                    </div>
                    <div>
                      <TextField
                        autoComplete="new-password"
                        name="paisresidente2"
                        style={{ width: "100%" }}
                        id="outlined-required"
                        label="Pais Residente"
                        {...register("paisresidente2")}
                        onBlur={onPaisResidente2}
                      />
                    </div>
                    <div>
                      <TextField
                        autoComplete="new-password"
                        name="paisresidente2snn"
                        style={{ width: "100%" }}
                        id="outlined-required"
                        label="Identificación del contribuyente en SNN"
                        {...register("paisresidente2snn")}
                        onBlur={onPaisResidente2SNN}
                      />
                    </div>
                  </SectionContainer2Columns>
                )}
                {isPais3 && (
                  <SectionContainer2Columns style={{ marginLeft: "0px" }}>
                    <div>
                      <TextField
                        autoComplete="new-password"
                        name="paisresidente1"
                        style={{ width: "100%" }}
                        id="outlined-required"
                        label="Pais Residente"
                        {...register("paisresidente1")}
                        onBlur={onPaisResidente1}
                      />
                    </div>
                    <div>
                      <TextField
                        autoComplete="new-password"
                        name="paisresidente1snn"
                        style={{ width: "100%" }}
                        id="outlined-required"
                        label="Identificación del contribuyente en SNN"
                        {...register("paisresidente1snn")}
                        onBlur={onPaisResidente1SNN}
                      />
                    </div>
                    <div>
                      <TextField
                        autoComplete="new-password"
                        name="paisresidente2"
                        style={{ width: "100%" }}
                        id="outlined-required"
                        label="Pais Residente"
                        {...register("paisresidente2")}
                        onBlur={onPaisResidente2}
                      />
                    </div>
                    <div>
                      <TextField
                        autoComplete="new-password"
                        name="paisresidente2snn"
                        style={{ width: "100%" }}
                        id="outlined-required"
                        label="Identificación del contribuyente en SNN"
                        {...register("paisresidente2snn")}
                        onBlur={onPaisResidente2SNN}
                      />
                    </div>
                    <div>
                      <TextField
                        autoComplete="new-password"
                        name="paisresidente3"
                        style={{ width: "100%" }}
                        id="outlined-required"
                        label="Pais Residente"
                        {...register("paisresidente3")}
                        onBlur={onPaisResidente3}
                      />
                    </div>
                    <div>
                      <TextField
                        autoComplete="new-password"
                        name="paisresidente3snn"
                        style={{ width: "100%" }}
                        id="outlined-required"
                        label="Identificación del contribuyente en SNN"
                        {...register("paisresidente3snn")}
                        onBlur={onPaisResidente3SNN}
                      />
                    </div>
                  </SectionContainer2Columns>
                )}
              </SectionContainer1Column>
            </>
          )}
        </SectionContainer1Column>
        {/************* INFORMACIÓN FINANCIERA *****************/}
        <TitleSection>
          Información Financiera
          <Tooltip
            title={
              <Typography fontSize={15}>
                Escriba un monto aproximado de sus activos y pasivos en los
                siguientes campos. En caso de no poseer, escriba el número 0.
              </Typography>
            }
            style={{ color: "#208037", fontSize: "30px" }}
            arrow
            placement="right"
          >
            <HelpIcon style={{ color: "#208037", marginLeft: "10px" }} />
          </Tooltip>
          <Divider />
        </TitleSection>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            justifyItems: "center",
            alignContent: "center",
            alignItems: "center",
          }}
        >
          {/* ***************** ACTIVOS ****************** */}
          <ActivePasiveText>Activos</ActivePasiveText>
        </div>
        <SectionContainer3Columns>
          <div>
            <TextField
              autoComplete="new-password"
              name="cajabanco"
              style={{
                width: "100%",
              }}
              type="number"
              id="outlined-required"
              label="Caja / Bancos"
              {...register("cajabanco")}
              error={errors.cajabanco ? true : false}
              onBlur={onCajaBancosChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">$</InputAdornment>
                ),
              }}
            />
            <Typography variant="inherit" color="red">
              {errors.cajabanco?.message}
            </Typography>
          </div>
          <div>
            <TextField
              autoComplete="new-password"
              name="cuentasxcobrar"
              style={{
                width: "100%",
              }}
              type="number"
              id="outlined-required"
              label="Cuentas por cobrar"
              {...register("cuentasxcobrar")}
              error={errors.cuentasxcobrar ? true : false}
              onBlur={onCuentasPorCobrarChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">$</InputAdornment>
                ),
              }}
            />
            <Typography variant="inherit" color="red">
              {errors.cuentasxcobrar?.message}
            </Typography>
          </div>
          <div>
            <TextField
              autoComplete="new-password"
              name="activosfijos"
              style={{
                width: "100%",
              }}
              type="number"
              id="outlined-required"
              label="Activos Fijos"
              {...register("activosfijos")}
              error={errors.activosfijos ? true : false}
              onBlur={onActivosFijosChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">$</InputAdornment>
                ),
              }}
            />
            <Typography variant="inherit" color="red">
              {errors.activosfijos?.message}
            </Typography>
          </div>
          <div>
            <TextField
              autoComplete="new-password"
              name="valorinversion"
              style={{
                width: "100%",
              }}
              type="number"
              id="outlined-required"
              label="Valor en Inversiones"
              {...register("valorinversion")}
              error={errors.valorinversion ? true : false}
              onBlur={onValorInversionesChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">$</InputAdornment>
                ),
              }}
            />
            <Typography variant="inherit" color="red">
              {errors.valorinversion?.message}
            </Typography>
          </div>
          <div>
            <TextField
              autoComplete="new-password"
              name="otrosactivos"
              style={{
                width: "100%",
              }}
              type="number"
              id="outlined-required"
              label="Otros Activos"
              {...register("otrosactivos")}
              error={errors.otrosactivos ? true : false}
              onBlur={onOtrosActivosChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">$</InputAdornment>
                ),
              }}
            />
            <Typography variant="inherit" color="red">
              {errors.otrosactivos?.message}
            </Typography>
          </div>

          <TextField
            autoComplete="new-password"
            style={{
              width: "100%",
            }}
            disabled
            type="number"
            id="outlined-required"
            label="Total de Activos"
            value={totalActivosValue}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">$</InputAdornment>
              ),
            }}
          />
          <div>
            <TextField
              autoComplete="new-password"
              name="ingresosmensuales"
              style={{
                width: "100%",
              }}
              type="number"
              id="outlined-required"
              label="Ingresos Mensuales"
              {...register("ingresosmensuales")}
              error={errors.ingresosmensuales ? true : false}
              onBlur={onIngresosMensualesChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">$</InputAdornment>
                ),
              }}
            />
            <Typography variant="inherit" color="red">
              {errors.ingresosmensuales?.message}
            </Typography>
          </div>
        </SectionContainer3Columns>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            justifyItems: "center",
            alignContent: "center",
            alignItems: "center",
          }}
        >
          {/* ***************** PASIVOS ****************** */}
          <ActivePasiveText style={{ marginTop: "20px" }}>
            Pasivos
          </ActivePasiveText>
        </div>
        <SectionContainer3Columns>
          <div>
            <TextField
              autoComplete="new-password"
              name="cuentasporpagar"
              style={{
                width: "100%",
              }}
              type="number"
              id="outlined-required"
              label="Cuentas por Pagar"
              {...register("cuentasporpagar")}
              error={errors.cuentasporpagar ? true : false}
              onBlur={onCuentasPorPagarChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">$</InputAdornment>
                ),
              }}
            />
            <Typography variant="inherit" color="red">
              {errors.cuentasporpagar?.message}
            </Typography>
          </div>
          <div>
            <TextField
              autoComplete="new-password"
              name="obligacionesfinancieras"
              style={{
                width: "100%",
              }}
              type="number"
              id="outlined-required"
              label="Obligaciones Financieras"
              {...register("obligacionesfinancieras")}
              error={errors.obligacionesfinancieras ? true : false}
              onBlur={onObligacionesFinancierasChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">$</InputAdornment>
                ),
              }}
            />
            <Typography variant="inherit" color="red">
              {errors.obligacionesfinancieras?.message}
            </Typography>
          </div>
          <div>
            <TextField
              autoComplete="new-password"
              name="otrospasivos"
              style={{
                width: "100%",
              }}
              type="number"
              id="outlined-required"
              label="Otros Pasivos"
              {...register("otrospasivos")}
              error={errors.otrospasivos ? true : false}
              onBlur={onOtrosPasivosChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">$</InputAdornment>
                ),
              }}
            />
            <Typography variant="inherit" color="red">
              {errors.otrospasivos?.message}
            </Typography>
          </div>

          <TextField
            autoComplete="new-password"
            style={{
              width: "100%",
            }}
            disabled
            type="number"
            id="outlined-required"
            label="Total de Pasivos"
            value={totalPasivosValue}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">$</InputAdornment>
              ),
            }}
          />
          <TextField
            autoComplete="new-password"
            style={{
              width: "100%",
            }}
            disabled
            type="number"
            id="outlined-required"
            label="Patrimonio"
            value={patrimonioValue}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">$</InputAdornment>
              ),
            }}
          />
          <div>
            <TextField
              autoComplete="new-password"
              name="egresosmensuales"
              style={{
                width: "100%",
              }}
              type="number"
              id="outlined-required"
              label="Egresos Mensuales"
              {...register("egresosmensuales")}
              error={errors.egresosmensuales ? true : false}
              onBlur={onEgresosMensualesChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">$</InputAdornment>
                ),
              }}
            />
            <Typography variant="inherit" color="red">
              {errors.egresosmensuales?.message}
            </Typography>
          </div>
        </SectionContainer3Columns>
        <TitleSection>
          Cuentas Bancarias
          <Divider />
        </TitleSection>
        <CuentasContainer>
          <div>
            <FormControl style={{ width: "100%" }}>
              <InputLabel id="demo-simple-select-label">
                # de Cuentas
              </InputLabel>
              <Select
                style={{ width: "50%" }}
                name="ncuentas"
                id="demo-simple-select-helper"
                labelId="demo-simple-select-label"
                label="# de Cuentas"
                MenuProps={{ disableScrollLock: true }}
                {...register("ncuentas")}
                error={errors.ncuentas ? true : false}
                value={nCuentasValue}
                onChange={onNCuentasChange}
              >
                <MenuItem value="1">1</MenuItem>
                <MenuItem value="2">2</MenuItem>
              </Select>
            </FormControl>
            <Typography variant="inherit" color="red">
              {errors.ncuentas?.message}
            </Typography>
          </div>
        </CuentasContainer>
        <SectionContainer3Columns>
          {isNCuentas && (
            //Cuenta 1
            <>
              <div>
                <TextField
                  autoComplete="new-password"
                  name="institucion1"
                  style={{
                    width: "100%",
                  }}
                  id="outlined-required"
                  label="Institucion Financiera"
                  {...register("institucion1")}
                  onBlur={onInstitucionFinanciera1Change}
                />
              </div>
              <div>
                <FormControl style={{ width: "100%" }}>
                  <InputLabel id="demo-simple-select-label">
                    Tipo de Cuenta
                  </InputLabel>
                  <Select
                    style={{ width: "100%" }}
                    name="tipocuenta1"
                    id="demo-simple-select-helper"
                    label="Tipo de Cuenta"
                    MenuProps={{ disableScrollLock: true }}
                    {...register("tipocuenta1")}
                    value={tipoCuentaValue}
                    onChange={onTipoCuentaChange}
                  >
                    <MenuItem value="Corriente">Corriente</MenuItem>
                    <MenuItem value="Ahorro">Ahorro</MenuItem>
                    <MenuItem value="Inversion">Inversión</MenuItem>
                  </Select>
                </FormControl>
              </div>
              <div>
                <TextField
                  autoComplete="new-password"
                  name="numerocuenta1"
                  style={{
                    width: "100%",
                  }}
                  type="number"
                  id="outlined-required"
                  label="Número de Cuenta"
                  {...register("numerocuenta1")}
                  onBlur={onNumeroCuenta1Change}
                />
              </div>
            </>
          )}
          {isNCuentas2 && (
            <>
              {/* Cuenta 1 */}
              <div>
                <TextField
                  autoComplete="new-password"
                  name="institucion1"
                  style={{
                    width: "100%",
                  }}
                  id="outlined-required"
                  label="Institucion Financiera"
                  {...register("institucion1")}
                  onBlur={onInstitucionFinanciera1Change}
                />
              </div>
              <div>
                <FormControl style={{ width: "100%" }}>
                  <InputLabel id="demo-simple-select-label">
                    Tipo de Cuenta
                  </InputLabel>
                  <Select
                    style={{ width: "100%" }}
                    name="tipocuenta1"
                    id="demo-simple-select-helper"
                    label="Tipo de Cuenta"
                    MenuProps={{ disableScrollLock: true }}
                    {...register("tipocuenta1")}
                    value={tipoCuentaValue}
                    onChange={onTipoCuentaChange}
                  >
                    <MenuItem value="Corriente">Corriente</MenuItem>
                    <MenuItem value="Ahorro">Ahorro</MenuItem>
                    <MenuItem value="Inversion">Inversión</MenuItem>
                  </Select>
                </FormControl>
              </div>
              <div>
                <TextField
                  autoComplete="new-password"
                  name="numerocuenta1"
                  style={{
                    width: "100%",
                  }}
                  type="number"
                  id="outlined-required"
                  label="Número de Cuenta"
                  {...register("numerocuenta1")}
                  onBlur={onNumeroCuenta1Change}
                />
              </div>
              {/* Cuenta 2 */}
              <div>
                <TextField
                  autoComplete="new-password"
                  name="institucion2"
                  style={{
                    width: "100%",
                  }}
                  id="outlined-required"
                  label="Institucion Financiera"
                  {...register("institucion2")}
                  onBlur={onInstitucionFinanciera2Change}
                />
              </div>
              <div>
                <FormControl style={{ width: "100%" }}>
                  <InputLabel id="demo-simple-select-label">
                    Tipo de Cuenta
                  </InputLabel>
                  <Select
                    style={{ width: "100%" }}
                    name="tipocuenta2"
                    id="demo-simple-select-helper"
                    label="Tipo de Cuenta"
                    MenuProps={{ disableScrollLock: true }}
                    {...register("tipocuenta2")}
                    value={tipoCuenta2Value}
                    onChange={onTipoCuenta2Change}
                  >
                    <MenuItem value="Corriente">Corriente</MenuItem>
                    <MenuItem value="Ahorro">Ahorro</MenuItem>
                    <MenuItem value="Inversion">Inversión</MenuItem>
                  </Select>
                </FormControl>
              </div>
              <div>
                <TextField
                  autoComplete="new-password"
                  name="numerocuenta2"
                  style={{
                    width: "100%",
                  }}
                  type="number"
                  id="outlined-required"
                  label="Número de Cuenta"
                  {...register("numerocuenta2")}
                  onBlur={onNumeroCuenta2Change}
                />
              </div>
            </>
          )}
        </SectionContainer3Columns>
        <TitleSection>
          Perfil de Riesgo
          <Divider />
        </TitleSection>
        <SectionContainer1Column>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div>
              <FormControl style={{ width: "100%" }}>
                <InputLabel id="demo-simple-select-label">
                  Objeto de la Inversión
                </InputLabel>
                <Select
                  style={{ width: "300px" }}
                  name="objinversion"
                  id="demo-simple-select-helper"
                  label="Objeto de la Inversión"
                  MenuProps={{ disableScrollLock: true }}
                  {...register("objinversion")}
                  error={errors.objinversion ? true : false}
                  value={objetoInversionValue}
                  onChange={onObjetoInversionChange}
                >
                  <MenuItem value="CortoPlazo">Corto Plazo</MenuItem>
                  <MenuItem value="MedianoPlazo">Mediano Plazo</MenuItem>
                  <MenuItem value="LargoPlazo">Largo Plazo</MenuItem>
                </Select>
              </FormControl>
              <Typography variant="inherit" color="red">
                {errors.objinversion?.message}
              </Typography>
            </div>

            <Tooltip
              title={
                <Typography fontSize={15}>
                  Ingresos económicos extras a corto, mediano o largo plazo.
                </Typography>
              }
              style={{ color: "#208037", fontSize: "30px" }}
              arrow
              placement="right"
            >
              <HelpIcon style={{ color: "#208037", marginLeft: "10px" }} />
            </Tooltip>
          </div>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div>
              <FormControl style={{ width: "100%" }}>
                <InputLabel id="demo-simple-select-label">
                  Necesidad de Liquidez
                </InputLabel>
                <Select
                  style={{ width: "300px" }}
                  name="necesidadliquidez"
                  id="demo-simple-select-helper"
                  label="Necesidad de Liquidez"
                  MenuProps={{ disableScrollLock: true }}
                  {...register("necesidadliquidez")}
                  error={errors.necesidadliquidez ? true : false}
                  value={necesidadLiquidezValue}
                  onChange={onNecesidadLiquidezChange}
                >
                  <MenuItem value="CortoPlazo">Corto Plazo</MenuItem>
                  <MenuItem value="MedianoPlazo">Mediano Plazo</MenuItem>
                  <MenuItem value="LargoPlazo">Largo Plazo</MenuItem>
                </Select>
              </FormControl>
              <Typography variant="inherit" color="red">
                {errors.necesidadliquidez?.message}
              </Typography>
            </div>

            <Tooltip
              title={
                <Typography fontSize={15}>
                  Depende de su necesidad elija a corto, mediano o largo plazo.
                </Typography>
              }
              style={{ color: "#208037", fontSize: "30px" }}
              arrow
              placement="right"
            >
              <HelpIcon style={{ color: "#208037", marginLeft: "10px" }} />
            </Tooltip>
          </div>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div>
              <FormControl style={{ width: "100%" }}>
                <InputLabel id="demo-simple-select-label">
                  Experiencia
                </InputLabel>
                <Select
                  style={{ width: "300px" }}
                  name="experiencia"
                  id="demo-simple-select-helper"
                  label="Experiencia"
                  MenuProps={{ disableScrollLock: true }}
                  {...register("experiencia")}
                  error={errors.experiencia ? true : false}
                  value={experienciaValue}
                  onChange={onExperienciaValue}
                >
                  <MenuItem value="Si">Si</MenuItem>
                  <MenuItem value="No">No</MenuItem>
                  <MenuItem value="Media">Media</MenuItem>
                </Select>
              </FormControl>
              <Typography variant="inherit" color="red">
                {errors.experiencia?.message}
              </Typography>
            </div>

            <Tooltip
              title={
                <Typography fontSize={15}>
                  Elija el nivel de experiencia que tiene al momento de realizar
                  inversiones.
                </Typography>
              }
              style={{ color: "#208037", fontSize: "30px" }}
              arrow
              placement="right"
            >
              <HelpIcon style={{ color: "#208037", marginLeft: "10px" }} />
            </Tooltip>
          </div>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div>
              <FormControl style={{ width: "100%" }}>
                <InputLabel id="demo-simple-select-label">
                  Plazo de la Inversión
                </InputLabel>
                <Select
                  style={{ width: "300px" }}
                  name="plazoinversion"
                  id="demo-simple-select-helper"
                  label="Plazo de la Inversión"
                  MenuProps={{ disableScrollLock: true }}
                  {...register("plazoinversion")}
                  error={errors.plazoinversion ? true : false}
                  value={plazoInversionValue}
                  onChange={onPlazoInversionChange}
                >
                  <MenuItem value="CortoPlazo">Corto Plazo</MenuItem>
                  <MenuItem value="MedianoPlazo">Mediano Plazo</MenuItem>
                  <MenuItem value="LargoPlazo">Largo Plazo</MenuItem>
                </Select>
              </FormControl>
              <Typography variant="inherit" color="red">
                {errors.plazoinversion?.message}
              </Typography>
            </div>

            <Tooltip
              title={
                <Typography fontSize={15}>
                  Depende de su disponibilidad de tiempo elija a corto, mediano
                  o largo plazo.
                </Typography>
              }
              style={{ color: "#208037", fontSize: "30px" }}
              arrow
              placement="right"
            >
              <HelpIcon style={{ color: "#208037", marginLeft: "10px" }} />
            </Tooltip>
          </div>

          <div style={{ display: "flex", flexDirection: "row" }}>
            <div>
              <FormControl style={{ width: "100%" }}>
                <InputLabel id="demo-simple-select-label">
                  Disponibilidad de Recursos
                </InputLabel>
                <Select
                  style={{ width: "300px" }}
                  name="disponibilidadrecursos"
                  id="demo-simple-select-helper"
                  label="Disponibilidad de Recursos"
                  MenuProps={{ disableScrollLock: true }}
                  {...register("disponibilidadrecursos")}
                  error={errors.disponibilidadrecursos ? true : false}
                  value={disponibilidadRecursosValue}
                  onChange={onDisponibilidadRecursosChange}
                >
                  <MenuItem value="Inmediato">Inmediato</MenuItem>
                  <MenuItem value="Programado">Programado</MenuItem>
                </Select>
              </FormControl>
              <Typography variant="inherit" color="red">
                {errors.disponibilidadrecursos?.message}
              </Typography>
            </div>

            <Tooltip
              title={
                <Typography fontSize={15}>
                  Inmediato de acuerdo a cada inversionista. Programado para
                  inversiones a largo plazo.
                </Typography>
              }
              style={{ color: "#208037", fontSize: "30px" }}
              arrow
              placement="right"
            >
              <HelpIcon style={{ color: "#208037", marginLeft: "10px" }} />
            </Tooltip>
          </div>
        </SectionContainer1Column>
        <TitleSection>
          Firma
          <Tooltip
            title={
              <Typography fontSize={15}>
                Subir una imagen de su firma
              </Typography>
            }
            style={{ color: "#208037" }}
            arrow
            placement="right"
          >
            <HelpIcon style={{ color: "#208037", marginLeft: "10px" }} />
          </Tooltip>
          <Divider />
        </TitleSection>
        <SectionContainer3Columns>
          <FileUpload
            value={firmaFileValue}
            onFilesChange={(value) => {
              setFirmaFileValue(value);
              setDisableIfUploadSignature(true);
            }}
            buttonText="Subir Firma"
            title="Firma"
            header="Arrastrar y soltar"
            multiFile={false}
            acceptedType={"image/*"}
            maxFileSize={10}
            disabled={disableIfMadeSignature ? true : false}
            showPlaceholderImage={false}
            buttonRemoveLabel="Eliminar"
            rightLabel="para seleccionar archivos"
            leftLabel="o"
            buttonLabel="Click aquí"
            maxUploadFiles={1}
          />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            O puede firmar directamente haciendo click en el botón FIRMAR AHORA
            <Popup
              modal
              trigger={
                <Button
                  style={{ marginTop: "22px" }}
                  variant="contained"
                  disabled={disableIfUploadSignature ? true : false}
                >
                  Firmar Ahora
                </Button>
              }
              closeOnDocumentClick={false}
            >
              {(close) => (
                <div>
                  <SignaturePad
                    penColor="black"
                    backgroundColor="white"
                    canvasProps={{
                      className: "sigCanvas",
                    }}
                    ref={sigCanvas}
                  />
                  {/* Button to trigger save canvas image */}
                  <br></br>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      columnGap: "10px",
                    }}
                  >
                    <Button
                      variant="contained"
                      onClick={() => {
                        save();
                        close();
                      }}
                    >
                      Guardar
                    </Button>
                    <Button variant="contained" onClick={clear}>
                      Limpiar
                    </Button>
                    <Button variant="contained" onClick={close}>
                      Cerrar
                    </Button>
                    <Button
                      variant="contained"
                      onClick={() => {
                        deleteSignature();
                        close();
                      }}
                    >
                      Eliminar Firma
                    </Button>
                  </div>
                </div>
              )}
            </Popup>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            Asegúrate que tu firma esté similar a la cédula.
            {imageURL ? (
              <img
                src={imageURL}
                alt="Firmar Fiduvalor"
                style={{
                  display: "block",
                  margin: "0 auto",
                  border: "1px solid black",
                  width: "150px",
                }}
              />
            ) : (
              <p>No ha firmado</p>
            )}
          </div>
          <div>
            <TextField
              autoComplete="new-password"
              name="nfirmante"
              style={{
                width: "100%",
              }}
              id="outlined-required"
              label="Nombre Completo del Firmante"
              {...register("nfirmante")}
              error={errors.nfirmante ? true : false}
              onBlur={onNombreCompletoFirmanteChange}
            />
            <Typography variant="inherit" color="red">
              {errors.nfirmante?.message}
            </Typography>
          </div>
          <div>
            <TextField
              autoComplete="new-password"
              name="cifirmante"
              style={{
                width: "100%",
              }}
              id="outlined-required"
              label="Cédula/Pasaporte del Firmante"
              {...register("cifirmante")}
              error={errors.cifirmante ? true : false}
              onBlur={onCedulaPasaporteFirmanteChange}
            />
            <Typography variant="inherit" color="red">
              {errors.cifirmante?.message}
            </Typography>
          </div>
        </SectionContainer3Columns>
        <TitleSection>
          Copia a color de cédula de ciudadanía del Representante Legal
          <Tooltip
            title={
              <Typography fontSize={15}>
                Subir un archivo en formato .pdf de la copia a color de la
                cédula de ciudadania requerida.
              </Typography>
            }
            style={{ color: "#208037" }}
            arrow
            placement="right"
          >
            <HelpIcon style={{ color: "#208037", marginLeft: "10px" }} />
          </Tooltip>
          <Divider />
        </TitleSection>
        <SectionContainer3Columns style={{ rowGap: "0px" }}>
          <FileUpload
            value={copiaCedulaTitularFileValue}
            onFilesChange={setCopiaCedulaTitularFileValue}
            buttonText="Subir Copia de Cédula "
            title="Copia de Cédula"
            header="Arrastrar y soltar"
            multiFile={false}
            acceptedType={"image/*,.pdf"}
            maxFileSize={10}
            showPlaceholderImage={false}
            buttonRemoveLabel="Eliminar"
            rightLabel="para seleccionar archivos"
            leftLabel="o"
            buttonLabel="Click aquí"
            maxUploadFiles={1}
          />
        </SectionContainer3Columns>
        <TitleSection>
          Copia de la papeleta de votación del representante Legal.
          <Tooltip
            title={
              <Typography fontSize={15}>
                Subir un archivo en formato .pdf de la copia de la papeleta de
                votación requerida.
              </Typography>
            }
            style={{ color: "#208037" }}
            arrow
            placement="right"
          >
            <HelpIcon style={{ color: "#208037", marginLeft: "10px" }} />
          </Tooltip>
          <Divider />
        </TitleSection>
        <SectionContainer3Columns style={{ rowGap: "0px" }}>
          <FileUpload
            value={copiaPapeletaTitularFileValue}
            onFilesChange={setCopiaPapeletaTitularFileValue}
            buttonText="Subir Copia de Papeleta"
            title="Copia de Papeleta"
            header="Arrastrar y soltar"
            multiFile={false}
            acceptedType={"image/*,.pdf"}
            maxFileSize={10}
            showPlaceholderImage={false}
            buttonRemoveLabel="Eliminar"
            rightLabel="para seleccionar archivos"
            leftLabel="o"
            buttonLabel="Click aquí"
            maxUploadFiles={1}
          />
        </SectionContainer3Columns>
        <TitleSection>
          Copia de la planilla de agua, luz o teléfono
          <Tooltip
            title={
              <Typography fontSize={15}>
                Subir un archivo en formato .pdf de la copia de la planilla de
                agua, luz o teléfono.
              </Typography>
            }
            style={{ color: "#208037" }}
            arrow
            placement="right"
          >
            <HelpIcon style={{ color: "#208037", marginLeft: "10px" }} />
          </Tooltip>
          <Divider />
        </TitleSection>
        <SectionContainer3Columns>
          <FileUpload
            value={copiaPlanillasFileValue}
            onFilesChange={setCopiaPlanillasFileValue}
            buttonText="Subir Copia de Planillas"
            title="Copia de Planillas"
            header="Arrastrar y soltar"
            multiFile={false}
            acceptedType={"image/*,.pdf"}
            maxFileSize={10}
            showPlaceholderImage={false}
            buttonRemoveLabel="Eliminar"
            rightLabel="para seleccionar archivos"
            leftLabel="o"
            buttonLabel="Click aquí"
            maxUploadFiles={1}
          />
        </SectionContainer3Columns>
        <TitleSection>
          Copia del nombramiento del representante legal o apoderado
          <Tooltip
            title={
              <Typography fontSize={15}>
                Subir un archivo en formato .pdf de la copia del nombramiento de
                del representante legal o apoderado
              </Typography>
            }
            style={{ color: "#208037" }}
            arrow
            placement="right"
          >
            <HelpIcon style={{ color: "#208037", marginLeft: "10px" }} />
          </Tooltip>
          <Divider />
        </TitleSection>
        <SectionContainer3Columns>
          <FileUpload
            value={copiaNombramientoFileValue}
            onFilesChange={setCopiaNombramientoFileValue}
            buttonText="Subir Copia de Nombramiento"
            title="Copia de Nombramiento del representante legal o apoderado aquí"
            header="Arrastrar y soltar"
            multiFile={false}
            acceptedType={"image/*,.pdf"}
            maxFileSize={10}
            showPlaceholderImage={false}
            buttonRemoveLabel="Eliminar"
            rightLabel="para seleccionar archivos"
            leftLabel="o"
            buttonLabel="Click aquí"
            maxUploadFiles={1}
          />
        </SectionContainer3Columns>
        <TitleSection>
          Copia de R. U. C
          <Tooltip
            title={
              <Typography fontSize={15}>
                Subir un archivo en formato .pdf de la copia RUC.
              </Typography>
            }
            style={{ color: "#208037" }}
            arrow
            placement="right"
          >
            <HelpIcon style={{ color: "#208037", marginLeft: "10px" }} />
          </Tooltip>
          <Divider />
        </TitleSection>
        <SectionContainer3Columns>
          <FileUpload
            value={copiaRUCFileValue}
            onFilesChange={setCopiaRUCFileValue}
            buttonText="Subir Copia de RUC"
            title="Copia de RUC"
            header="Arrastrar y soltar"
            multiFile={false}
            acceptedType={"image/*,.pdf"}
            maxFileSize={10}
            showPlaceholderImage={false}
            buttonRemoveLabel="Eliminar"
            rightLabel="para seleccionar archivos"
            leftLabel="o"
            buttonLabel="Click aquí"
            maxUploadFiles={1}
          />
        </SectionContainer3Columns>
        <TitleSection>
          Copia de la escritura de constitución
          <Tooltip
            title={
              <Typography fontSize={15}>
                Subir un archivo en formato .pdf de la copia de la escritura de
                constitución
              </Typography>
            }
            style={{ color: "#208037" }}
            arrow
            placement="right"
          >
            <HelpIcon style={{ color: "#208037", marginLeft: "10px" }} />
          </Tooltip>
          <Divider />
        </TitleSection>
        <SectionContainer3Columns>
          <FileUpload
            value={copiaEscrituraFileValue}
            onFilesChange={setCopiaEscrituraFileValue}
            buttonText="Subir Copia de Escritura"
            title="Copia de Escritura de Constitución"
            header="Arrastrar y soltar"
            multiFile={false}
            acceptedType={"image/*,.pdf"}
            maxFileSize={10}
            showPlaceholderImage={false}
            buttonRemoveLabel="Eliminar"
            rightLabel="para seleccionar archivos"
            leftLabel="o"
            buttonLabel="Click aquí"
            maxUploadFiles={1}
          />
        </SectionContainer3Columns>
        <TitleSection>
          Copia de los estatutos sociales vigentes y/o últimas reformas
          <Tooltip
            title={
              <Typography fontSize={15}>
                Subir un archivo en formato .pdf de la copia de los estatutos
                sociales vigentes y/o últimas reformas
              </Typography>
            }
            style={{ color: "#208037" }}
            arrow
            placement="right"
          >
            <HelpIcon style={{ color: "#208037", marginLeft: "10px" }} />
          </Tooltip>
          <Divider />
        </TitleSection>
        <SectionContainer3Columns>
          <FileUpload
            value={copiaEstatutosFileValue}
            onFilesChange={setCopiaEstatutosFileValue}
            buttonText="Subir Copia de Estatutos Sociales"
            title="Copia de Estatutos Sociales"
            header="Arrastrar y soltar"
            multiFile={false}
            acceptedType={"image/*,.pdf"}
            maxFileSize={10}
            showPlaceholderImage={false}
            buttonRemoveLabel="Eliminar"
            rightLabel="para seleccionar archivos"
            leftLabel="o"
            buttonLabel="Click aquí"
            maxUploadFiles={1}
          />
        </SectionContainer3Columns>
        <TitleSection>
          Certificado Bancario
          <Tooltip
            title={
              <Typography fontSize={15}>
                Subir un archivo en formato .pdf de la copia del certificado
                bancario. En caso de no poseer uno, solicite en su banco.
              </Typography>
            }
            style={{ color: "#208037" }}
            arrow
            placement="right"
          >
            <HelpIcon style={{ color: "#208037", marginLeft: "10px" }} />
          </Tooltip>
          <Divider />
        </TitleSection>
        <SectionContainer3Columns>
          <FileUpload
            value={copiaCertificadoBancarioFileValue}
            onFilesChange={setCopiaCertificadoBancarioFileValue}
            buttonText="Subir Copia de Certificado Bancario"
            title="Copia de Certificado Bancario"
            header="Arrastrar y soltar"
            multiFile={false}
            acceptedType={"image/*,.pdf"}
            maxFileSize={10}
            showPlaceholderImage={false}
            buttonRemoveLabel="Eliminar"
            rightLabel="para seleccionar archivos"
            leftLabel="o"
            buttonLabel="Click aquí"
            maxUploadFiles={1}
          />
        </SectionContainer3Columns>
        <TitleSection>
          Estados financieros auditados, mínimo de dos años atrás
          <Tooltip
            title={
              <Typography fontSize={15}>
                Suba un documento pdf de los Estados financieros auditados,
                mínimo de dos años atrás
              </Typography>
            }
            style={{ color: "#208037" }}
            arrow
            placement="right"
          >
            <HelpIcon style={{ color: "#208037", marginLeft: "10px" }} />
          </Tooltip>
          <Divider />
        </TitleSection>
        <SectionContainer3Columns>
          <FileUpload
            value={copiaEstadosFinancierosFileValue}
            onFilesChange={setCopiaEstadosFinancierosFileValue}
            buttonText="Subir Copia de Estados Financieros"
            title="Copia de Estados Financieros Financieros"
            header="Arrastrar y soltar"
            multiFile={false}
            acceptedType={"image/*,.pdf"}
            maxFileSize={10}
            showPlaceholderImage={false}
            buttonRemoveLabel="Eliminar"
            rightLabel="para seleccionar archivos"
            leftLabel="o"
            buttonLabel="Click aquí"
            maxUploadFiles={1}
          />
        </SectionContainer3Columns>
        <TitleSection>
          Nómina de accionistas o socios que tengan directa o indirectamente el
          6% o más del capital suscrito de la compañía,otorgada por el órgano de
          control competente.
          <Tooltip
            title={
              <Typography fontSize={15}>
                Suba un documento pdf de la nómina solicitada.
              </Typography>
            }
            style={{ color: "#208037" }}
            arrow
            placement="right"
          >
            <HelpIcon style={{ color: "#208037", marginLeft: "10px" }} />
          </Tooltip>
          <Divider />
        </TitleSection>
        <SectionContainer3Columns>
          <FileUpload
            value={copiaNominaAccionistasFileValue}
            onFilesChange={setCopiaNominaAccionistasFileValue}
            buttonText="Subir Copia de Nómina de Accionistas"
            title="Copia de Nómina de Accionistas"
            header="Arrastrar y soltar"
            multiFile={false}
            acceptedType={"image/*,.pdf"}
            maxFileSize={10}
            showPlaceholderImage={false}
            buttonRemoveLabel="Eliminar"
            rightLabel="para seleccionar archivos"
            leftLabel="o"
            buttonLabel="Click aquí"
            maxUploadFiles={1}
          />
        </SectionContainer3Columns>
        <TitleSection>
          Certificado de cumplimiento de obligaciones otorgado por el órgano de
          control competente.
          <Tooltip
            title={
              <Typography fontSize={15}>
                Suba un documento pdf del certificado de cumplimiento de
                obligaciones.
              </Typography>
            }
            style={{ color: "#208037" }}
            arrow
            placement="right"
          >
            <HelpIcon style={{ color: "#208037", marginLeft: "10px" }} />
          </Tooltip>
          <Divider />
        </TitleSection>
        <SectionContainer3Columns>
          <FileUpload
            value={copiaCertificadoCumplimiento}
            onFilesChange={setCopiaCertificadoCumplimiento}
            buttonText="Subir Copia de Certificado de Cumplimiento"
            title="Copia de Certificado de Cumplimiento"
            header="Arrastrar y soltar"
            multiFile={false}
            acceptedType={"image/*,.pdf"}
            maxFileSize={10}
            showPlaceholderImage={false}
            buttonRemoveLabel="Eliminar"
            rightLabel="para seleccionar archivos"
            leftLabel="o"
            buttonLabel="Click aquí"
            maxUploadFiles={1}
          />
        </SectionContainer3Columns>
        <TitleSection>
          Copia de la Declaración del Impuesto a la Renta año inmediato anterior
          <Tooltip
            title={
              <Typography fontSize={15}>
                Suba un archivo .pdf de la copia de la declaración de impuestos
                a la renta del año inmediato anterior.
              </Typography>
            }
            style={{ color: "#208037" }}
            arrow
            placement="right"
          >
            <HelpIcon style={{ color: "#208037", marginLeft: "10px" }} />
          </Tooltip>
          <Divider />
        </TitleSection>
        <SectionContainer3Columns>
          <FileUpload
            value={copiaDeclaracionImpuestosFileValue}
            onFilesChange={setCopiaDeclaracionImpuestosFileValue}
            buttonText="Subir Copia de Declaración de Impuestos"
            title="Copia de Declaración de Impuestos"
            header="Arrastrar y soltar"
            multiFile={false}
            acceptedType={"image/*,.pdf"}
            maxFileSize={10}
            showPlaceholderImage={false}
            buttonRemoveLabel="Eliminar"
            rightLabel="para seleccionar archivos"
            leftLabel="o"
            buttonLabel="Click aquí"
            maxUploadFiles={1}
          />
        </SectionContainer3Columns>
        {/* DECLARACIÓN !!!!! */}
        <TitleSection>
          Declaro bajo juramento que:
          <Divider />
        </TitleSection>
        <SectionContainer3Columns>
          <FormControl>
            <FormLabel id="demo-row-radio-buttons-group-label">
              Los Fondos Provienen De
            </FormLabel>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
              onChange={onDeclaraChange}
            >
              <SectionContainer1Column
                style={{ marginLeft: "0px", rowGap: "6px" }}
              >
                <FormControlLabel
                  value="Actividad Propia de la Compañía"
                  control={<Radio />}
                  label="Actividad Propia de la Compañía"
                />
                <FormControlLabel
                  value="Venta de Activos"
                  control={<Radio />}
                  label="Venta de Activos"
                />
                <FormControlLabel
                  value="Otros"
                  control={<Radio />}
                  label="Otros"
                />
                {isDeclaring && (
                  <TextField
                    autoComplete="new-password"
                    name="otrodeclara"
                    style={{ width: "100%" }}
                    id="outlined-multiline-flexible"
                    label="Explicar"
                    {...register("otrodeclara")}
                    onBlur={onOtroDeclaraChange}
                    variant="outlined"
                    multiline
                    maxRows={5}
                  />
                )}
              </SectionContainer1Column>
            </RadioGroup>
          </FormControl>
        </SectionContainer3Columns>
        <TitleSection>
          La información proporcionada en este formulario es correcta y
          completa.
          <Divider />
        </TitleSection>
        <SectionContainer2Columns>
          <TextField
            autoComplete="new-password"
            id="outlined-multiline-flexible"
            label="Términos"
            multiline
            maxRows={10}
            value={multilineValue}
            variant="outlined"
            disabled
          />
          <div>
            <FormControlLabel
              control={
                <Checkbox
                  value={hasAccepted}
                  onChange={() => {
                    setHasAccepted(!hasAccepted);
                  }}
                />
              }
              label="Acepto y certifico que la información proporcionada es correcta y completa"
            />
          </div>
        </SectionContainer2Columns>
        <SectionContainer1Column>
          <Typography variant="body1" style={{ marginTop: "20px" }}>
            <span
              style={{
                color: "#208037",
                fontWeight: "bold",
              }}
            >
              NOTA:{" "}
            </span>
            Al enviar el formulario confirmo haber leído y aceptado los{" "}
            <span
              style={{
                color: "#208037",
                fontWeight: "bold",
                cursor: "pointer",
              }}
              onClick={() => {
                window.open(
                  "https://fiduvalor.com.ec/terminos-y-condiciones",
                  "_blank"
                );
              }}
            >
              términos y condiciones y política de privacidad de Fiduvalor{" "}
            </span>
            .
          </Typography>
        </SectionContainer1Column>
        <SectionContainer2Columns style={{ marginTop: "50px" }}>
          {hasAccepted && (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  alignContent: "center",
                }}
              >
                <Button
                  sx={{
                    color: "black",
                    border: "2px solid #208037",
                    fontSize: "20px",
                    fontFamily: "Poppins",
                  }}
                  variant="outlined"
                  type="submit"
                >
                  Continuar
                </Button>
              </div>
            </>
          )}
        </SectionContainer2Columns>
      </form>
      <LoadingForm isLoading={isLoading} progress={progress} />
    </MainContainer>
  );
};

function LoadingForm(props) {
  const { isLoading, progress } = props;

  return (
    <Dialog
      open={isLoading}
      keepMounted
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>{"¡Formulario Completado!"}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">
          Gracias por confíar en FIDUVALOR. Nos encontramos envíando tu
          información, por favor espere unos segundos.
        </DialogContentText>
        <Box
          sx={{ display: "flex", justifyContent: "center", marginTop: "20px" }}
        >
          <CircularProgressWithLabel progress={progress} />
        </Box>
      </DialogContent>
    </Dialog>
  );
}

function CircularProgressWithLabel(props) {
  const { progress } = props;
  return (
    <Box sx={{ position: "relative", display: "inline-flex" }}>
      <CircularProgress variant="determinate" value={progress} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography variant="caption" component="div" color="text.secondary">
          {`${Math.round(progress)}%`}
        </Typography>
      </Box>
    </Box>
  );
}

export default FormJuridicalAll;
